import CompanySelector from "ATSComponents/Common/CompanySelector"
import LinkCandidate from "ATSComponents/Common/LinkCandidate"
import LinkContactsPopup from "ATSComponents/Common/LinkContactsPopup"
import axios from "axios"
import { FilterMatchMode } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { InputTextarea } from "primereact/inputtextarea"
import { ProgressSpinner } from "primereact/progressspinner"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { setPageData } from "store/actions"
import { callReportSourceApi } from "utils/ApiClients"
import { formatDate, triggerAlert } from "utils/CommonFunctions"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { menuIdData } from "../../utils/Constants"
import { MultiSelect } from 'primereact/multiselect';
import { set } from "store"
import SuccessErrorPopup from "ATSComponents/Common/SuccessErrorPopup"
import Swal from "sweetalert2"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import { getCandidateIds, getCandidateNames } from "./calendarCandidateUtils"
import { getCalendarApiErrorMessage } from "./calendarError"

const isAllCalendarCompany = companyId => String(companyId || "").toLowerCase() === "all"
const blockAllCompanyMutation = () => {
  Swal.fire({
    icon: "warning",
    title: "Select a company",
    text: "Please select a specific company before editing, archiving, or deleting a calendar event.",
    confirmButtonText: "OK",
  })
}
const CalenderAll = () => {
  const dispatch = useDispatch()
  const [addPermission, setAddPermission] = useState(false)
  const [editPermission, setEditPermission] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [viewPermission, setViewPermission] = useState(false)
  const [totalRecordsJobs, setTotalRecordsJobs] = useState(0)
  const [totalRecordsContacts, setTotalRecordsContacts] = useState(0)
  const [totalRecordsCandidates, setTotalRecordsCandidates] = useState(0)
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedContactsLocal, setSelectedContactsLocal] = useState([]);
  const [parentContacts, setParentContacts] = useState([]);
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
  const [companies, setCompanies] = useState([]);
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedEventForShare, setSelectedEventForShare] = useState(null);
  const [modalCompanyId, setModalCompanyId] = useState(null)
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  const [selectedCandidatesShare, setSelectedCandidatesShare] = useState([]);
  const [isSharing, setIsSharing] = useState(false);
  const [recruiterFilter, setRecruiterFilter] = useState("");
//   const recruiterOptions = allRecruiters.filter(r =>
//   r.name.toLowerCase().includes(recruiterFilter.toLowerCase())
// );

  const handleShareClick = (rowData) => {
    setSelectedEventForShare(rowData);
    setSelectedRecruiters([]);
    setSelectedCandidatesShare([]);
    setShowShareModal(true);
  };
  const handleRecruiterChange = (e) => {
  setSelectedRecruiters(e.value);

  // clear search instantly
  setRecruiterFilter("");
};

    const handleCompaniesLoaded = (list) => {
    setCompanies(list);
  };

  const CustomLoader = () => (
  <div style={{ padding: "40px", textAlign: "center" }}>
    <span className="spinner-border text-primary" role="status" />
    <div style={{ marginTop: "10px", fontWeight: "500" }}>
      Loading ...
    </div>
  </div>
);
useEffect(() => {
  if (!showShareModal || !modalCompanyId) return;
  getallactivecontacts(modalCompanyId);
}, [modalCompanyId, showShareModal]);

useEffect(() => {
  if (showShareModal && companyId) {
    setModalCompanyId(companyId);
  }
}, [showShareModal, companyId]);


  document.title = "ATS - Calender"

  useEffect(() => {
    const menu_id = menuIdData?.AllCalendar
    setAddPermission(get_user_menu_permission(menu_id, "add"))
    setEditPermission(get_user_menu_permission(menu_id, "edit"))
    setDeletePermission(get_user_menu_permission(menu_id, "delete"))
    setViewPermission(get_user_menu_permission(menu_id, "view"))
  }, [])

  const [totalRecords, setTotalRecords] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [fullData, setFullData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  // const { first, rows, totalRecords } = useSelector(
  //   state => state.calendar.pagination
  // )

  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const emailOptions = [
    { label: "1 Selected" },
    { label: "2 Selected" },
    { label: "3 Selected" },
    { label: "4 Selected" },
    { label: "5 Selected" },
  ]
  const jobOptions = [
    { name: "Developer", value: "developer" },
    { name: "Designer", value: "designer" },
    { name: "Manager", value: "manager" },
  ]
  const candidateOptions = [
    { name: "Ram", value: "ram" },
    { name: "Sam", value: "sam" },
    { name: "John", value: "john" },
  ]

  const [filteredJobslink, setFilteredJobslink] = useState([])
  const [totalRecordsjob1, setTotalRecordsjob1] = useState(0)
  const [filteredContacts, setFilteredContacts] = useState([])
  const [filteredCandidates, setFilteredCandidates] = useState([])
  const [jobPage, setJobPage] = useState(1)
  const [jobRows, setJobRows] = useState(10)
  const [jobLazyParams, setJobLazyParams] = useState({ page: 0, rows: 10 });
  const [contactLazyParams, setContactLazyParams] = useState({ page: 0, rows: 10 });
  const [candidateLazyParams, setCandidateLazyParams] = useState({ page: 0, rows: 10 });
  const [typeInterviewcontact, settypeInterviewcontact] = useState([]);
  const filteredRecruiters = typeInterviewcontact
    .filter((contact) =>
      contact.name.toLowerCase().includes(recruiterFilter.toLowerCase())
    )
    .map((contact) => ({
      label: contact.name,
      value: contact.id,
    }));

  const [loading1,setLoading1]=useState(false)
  const getallactivecontacts = async (page, size) => {
      try {
        setLoading1(true);
        const response = await axios.get(
          `/api/v1/get-all-recruiters/?company_id=${modalCompanyId}`
        );
      const data = response.data.results || response.data || [];

      const transformedData = data.map(contact => ({
        id: contact.id,
         name: `${contact?.first_name} ${contact?.middle_name} ${contact?.last_name}`,
      }));
      settypeInterviewcontact(transformedData);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      } finally {
        setLoading1(false);
      }
    };
  const getjobvallist = async (page, size) => {
    try {
      const response = await axios.get(
        `/api/v1/jobs/?page=${page + 1}&size=${size}&status=Approved / Open`,
        {}
      )
      if (response.data) {
        setFilteredJobslink(response.data.results || [])
        const count =
          response.data.count !== undefined ? response.data.count : 0
        setTotalRecordsJobs(count)
      } else {
        console.log("No data in response")
        setFilteredJobslink([])
        setTotalRecordsJobs(0)
      }
    } catch (error) {
      console.error("Error fetching jobs:", error)
      setFilteredJobslink([])
      setTotalRecordsjob1(0)
    }
  }
const recruiterTooltip =
  selectedRecruiters?.length
    ? typeInterviewcontact
        .filter(contact => selectedRecruiters.includes(contact.id))
        .map(contact => contact.name)
        .join(", ")
    : "Select Employee/Recruiter";

  const onJobPageChange = (event) => {
    setJobLazyParams({ page: event.page, rows: event.rows });
  };
  const onContactPageChange = (event) => {
    setContactLazyParams({ page: event.page, rows: event.rows });
  };
  const onCandidatePageChange = (event) => {
    setCandidateLazyParams({ page: event.page, rows: event.rows });
  };

  // useEffect(() => {
  //   getjobvallist(jobLazyParams.page, jobLazyParams.rows);
  // }, [jobLazyParams]);

  // useEffect(() => {
  //   getContactList(contactLazyParams.page, contactLazyParams.rows);
  // }, [contactLazyParams]);

  // useEffect(() => {
  //   getCandidateList(candidateLazyParams.page, candidateLazyParams.rows);
  // }, [candidateLazyParams]);


  const selectedEmailTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const emailOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subtype: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    recruiter_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reminder: { value: null, matchMode: FilterMatchMode.EQUALS },
    reminderDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    startDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    endDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    completed: { value: null, matchMode: FilterMatchMode.EQUALS },
    private: { value: null, matchMode: FilterMatchMode.EQUALS },
    user_ids: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    archived: { value: null, matchMode: FilterMatchMode.EQUALS },
    auto_followup: { value: null, matchMode: FilterMatchMode.EQUALS },
    calendar_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    candidate_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    contact_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    created_by: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    end_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    external_calendar_event_id: {
      value: null,
      matchMode: FilterMatchMode.EQUALS,
    },
    job_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    recurring: { value: null, matchMode: FilterMatchMode.EQUALS },
    reminder_note: { value: null, matchMode: FilterMatchMode.CONTAINS },
    repeat: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  })
  const onFilter = (event) => {
    const { filters: updatedFilters } = event;
    setFilters(updatedFilters);
    const isActive = Object.values(updatedFilters).some(
      (filter) => filter.value !== null && filter.value !== ""
    );
    setIsFilterActive(isActive);

    let filtered = [...fullData];
    const globalValue = updatedFilters.global?.value?.toLowerCase() || "";

    filtered = filtered.filter((row) => {
      const matchGlobal =
        !globalValue ||
        Object.values(row).some((v) =>
          String(v).toLowerCase().includes(globalValue)
        );

      // now check each field-specific filter dynamically
      const matches = Object.entries(updatedFilters).every(([field, { value, matchMode }]) => {
        if (!value || field === "global") return true;
        const fieldValue = String(row[field] ?? "").toLowerCase();
        const searchValue = String(value).toLowerCase();

        switch (matchMode) {
          case FilterMatchMode.STARTS_WITH:
            return fieldValue.startsWith(searchValue);
          case FilterMatchMode.CONTAINS:
            return fieldValue.includes(searchValue);
          case FilterMatchMode.EQUALS:
            return fieldValue === searchValue;
          default:
            return true;
        }
      });

      return matchGlobal && matches;
    });

    setProcessedData(filtered);
  };
  const [tableData, setTableData] = useState([])
  const [selectedTableData, setSelectedTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState([])
  const [job, setJob] = useState(null)
  const [selectedJobTitles, setSelectedJobTitles] = useState("")
  const [jobSearchText, setJobSearchText] = useState("")
  const [jobFilters, setJobFilters] = useState({
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  //contacts state
  const [contact, setContact] = useState(null)
  const [selectedContacts, setSelectedContacts] = useState([])
  const [contactDetailsVisible, setContactDetailsVisible] = useState(false)
  const [selectedContactNames, setSelectedContactNames] = useState("")
  const [contactSearchText, setContactSearchText] = useState("")
  const [contactFilters, setContactFilters] = useState({
    first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  //candidate
  const [candidate, setCandidate] = useState(null)
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [candidateDetailsVisible, setCandidateDetailsVisible] = useState(false)
  const [selectedCandidateNames, setSelectedCandidateNames] = useState("")
  const [candidateSearchText, setCandidateSearchText] = useState("")
  const [candidateFilters, setCandidateFilters] = useState({
    first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const getContactList = async (page, size) => {
    try {
      const response = await axios.get(
        `/api/v1/contacts/?page=${page + 1}&size=${size}&status=Active&company_id=${companyId}`,
        {}
      )
      if (response.data) {
        setFilteredContacts(response.data.results)
        setTotalRecordsContacts(response?.data?.count)
      }
      else {
        setFilteredContacts([])
        setTotalRecordsContacts(0)
      }
    } catch (error) {
      console.log("Error fetching contacts:", error)
    }
  }

  const handleSaveContact = () => {
    const selectedContactNames = Array.isArray(selectedContacts)
      ? selectedContacts.map(contact => contact.first_name).join(", ")
      : ""
    setSelectedContactNames(selectedContactNames)
    setContact(
      selectedContacts.length > 0
        ? selectedContacts.map(contact => ({
          name: contact.first_name,
          value: contact.id,
        }))
        : null
    )
    setContactDetailsVisible(false)
    setContactSearchText("")
    setContactFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleContactIconClick = () => {
    setContactDetailsVisible(true)
  }

  const handleContactRefresh = () => {
    setSelectedContacts([])
    setSelectedContactNames("")
    setContactSearchText("")
    setContactFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const getCandidateList = async (page, size) => {
    try {
      const response = await axios.get(
        `/api/v1/candidates/?page=${page + 1}&size=${size}&status=Active&company_id=${companyId}`,
        {}
      )
      if (response.data) {
        setFilteredCandidates(response?.data?.results)
        setTotalRecordsCandidates(response?.data?.count)
      }
      else {
        setFilteredCandidates([])
        setTotalRecordsCandidates(0)
      }
    } catch (error) {
      console.log("Error fetching candidates:", error)
    }
  }

  const handleCandidateIconClick = () => {
    setCandidateDetailsVisible(true)
  }

  const handleSaveCandidate = () => {
    const selectedCandidateNames = Array.isArray(selectedCandidates)
      ? selectedCandidates.map(candidate => candidate.first_name).join(", ")
      : ""
    setSelectedCandidateNames(selectedCandidateNames)
    setCandidate(
      selectedCandidates.length > 0
        ? selectedCandidates.map(candidate => ({
          name: candidate.first_name,
          value: candidate.candidate_id,
        }))
        : null
    )
    setCandidateDetailsVisible(false)
    setCandidateSearchText("")
    setCandidateFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleCandidateRefresh = () => {
    setSelectedCandidates([])
    setSelectedCandidateNames("")
    setCandidateSearchText("")
    setCandidateFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  // const fetchAllCanlendersList = async (page = 1) => {
  //   try {
  //     const response = await callReportSourceApi(`/?page=${page}&size=${rows}`)
  //     const apiData = response.data.results
  //     dispatch(
  //       setPageData({
  //         first: (page - 1) * rows,
  //         rows: rows || 10,
  //         totalRecords: response.data.count,
  //       })
  //     )
  //     const transformedData = apiData.map(item => ({
  //       id: item.calendar_id,
  //       type: item.event_type,
  //       subtype: item.event_sub_type,
  //       subject: item.subject,
  //       reminder: item.reminder ? item.reminder.replace("m", "") : "",
  //       reminderDate: item.start_date,
  //       startDate: item.start_date,
  //       endDate: item.end_date,
  //       completed: item.completed,
  //       private: item.private,
  //       user_ids: Array.isArray(item.user_ids) ? item.user_ids : [],
  //       created_by_name: item.created_by_name,
  //       archived: item.archived,
  //       auto_followup: item.auto_followup,
  //       calendar_id: item.calendar_id,
  //       candidate_ids: Array.isArray(item.candidate_ids) ? item.candidate_ids : item.candidate_id ? [item.candidate_id] : [],
  //       contact_ids: Array.isArray(item.contact_ids) ? item.contact_ids : item.contact_id ? [item.contact_id] : [],
  //       created_by: item.created_by ? item.created_by.toString() : "",
  //       description: item.description,
  //       end_time: item.end_time,
  //       event_priority: item.event_priority,
  //       event_time: item.event_time ? item.event_time.split("T")[0] : "",
  //       external_calendar_event_id: item.external_calendar_event_id,
  //       job_ids: Array.isArray(item.job_ids) ? item.job_ids : item.job_id ? [item.job_id] : [],
  //       recurring: item.recurring,
  //       reminder_note: item.reminder_note,
  //       repeat: item.repeat,
  //       start_time: item.start_time,
  //       status: item.status,
  //     }))
  //     setTableData(transformedData)
  //   } catch (error) {
  //     console.log("error", error.message)
  //   }
  // }
  const fetchAllCanlendersList = async (page, size) => {
    setLoading(true);
    try {
      const response = await callReportSourceApi(`/?page=${page}&size=${size}&company_id=${companyId}`);
      const apiData = response.data.results;
      dispatch(
        setPageData({
          first: (page - 1) * rows,
          rows: rows || 10,
          totalRecords: response.data.count,
        })
      );
      setTotalRecords(response.data.count);
      const transformedData = apiData.map(item => {
        const userIds = Array.isArray(item.user_ids) ? item.user_ids : item.user_ids ? [item.user_ids] : [];
        const calenditData = item.calendit_response?.results?.data;
        const hasCalendit = Array.isArray(calenditData) && calenditData.length > 0;
        const calendit = hasCalendit ? calenditData[0] : null;
        return {
            ...item,
          id: item.calendar_id,
          type: item.event_type,
          subtype: item.event_sub_type,
          subject: item.subject,
          reminder: item.reminder || "",
          reminderDate: item.start_date,
          startDate: item.start_date,
          endDate: item.end_date,
          completed: item.completed,
          private: item.private,
          user_ids: userIds, // Use the sanitized array
          created_by_name: item.created_by_name,
          archived: item.archived,
          auto_followup: item.auto_followup,
          calendar_id: item.calendar_id,
          candidate_ids: Array.isArray(item.candidate_ids) ? item.candidate_ids : item.candidate_id ? [item.candidate_id] : [],
          contact_ids: Array.isArray(item.contact_ids) ? item.contact_ids : item.contact_id ? [item.contact_id] : [],
          created_by: item.created_by ? item.created_by.toString() : "",
          description: item.description,
          end_time: item.end_time,
          event_priority: item.event_priority,
          event_time: item.event_time ? item.event_time.split("T")[0] : "",
          external_calendar_event_id: item.external_calendar_event_id,
          job_ids: Array.isArray(item.job_ids) ? item.job_ids : item.job_id ? [item.job_id] : [],
          recurring: item.recurring,
          reminder_note: item.reminder_note,
          repeat: item.repeat,
          start_time: item.start_time,
          status: item.status,
          duration: item.duration,
          selected_date: calendit?.selected_date || "-",
          selected_time: calendit?.selected_time || "-",
          meeting_link: calendit?.meeting_link || "N/A",
          participant_link: calendit?.participant_link || null,
          google_calendar_link: calendit?.google_calendar_link || null,
        };
      });
      setTableData(transformedData);
      const processedData = transformedData.map(item => ({
        ...item,
        candidate_name: getCandidateNames(item.candidate_ids),
        recruiter_name: item.contact_ids?.map(c => c.name).join(", ") || "N/A",
      }));
      setProcessedData(processedData);
      setFullData(processedData);
      // console.info("Transformed Data:", transformedData);
    } catch (error) {
      console.log("Error fetching calendar data:", error.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
useEffect(()=>{
  fetchAllCanlendersList(1, rows)
},[companyId])

  // const processedData = tableData.map(item => ({
  //   ...item,
  //   candidate_name: item.candidate_ids?.[0]?.name || "N/A",
  //   recruiter_name: item.contact_ids?.map(c => c.name).join(", ") || "N/A",
  // }));

  const ensureCandidateInList = async (candidateId) => {
    let candidate = filteredCandidates.find(c => c.candidate_id === candidateId);
    if (!candidate) {
      // Fetch candidate by ID if not present
      try {
        const response = await axios.get(`/api/v1/candidates/${candidateId}/`);
        candidate = response.data;
        setFilteredCandidates(prev => [...prev, candidate]);
      } catch (error) {
        // handle error or ignore
      }
    }
    return candidate;
  };


  // rows change is handled by onPage, no separate useEffect needed

  const onPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.first / event.rows + 1;
    fetchAllCanlendersList(page, event.rows);
  };

  const dt = useRef(null)

  const exportCSV = selectionOnly => {
    dt.current.exportCSV({ selectionOnly })
  }

  const reminderCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, reminder: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.reminder}
        onChange={handleCheckboxChange}
      />
    )
  }

  const completedCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, completed: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.completed}
        onChange={handleCheckboxChange}
        disabled
      />
    )
  }

  const reminderTemplate = rowData => {
    if (!rowData.reminder) return <span>None</span>;
    // If reminder is like "10m", extract the number and display "10 minutes"
    const match = rowData.reminder.match(/^(\d+)m$/);
    if (match) {
      return <span>{match[1]} minutes</span>;
    }
    return <span>{rowData.reminder}</span>;
  };

  const privateCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, private: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.private}
        onChange={handleCheckboxChange}
        disabled
      />
    )
  }

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [scheduleDuration, setScheduleDuration] = useState(null);

  const handleDeleteSelected = () => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    setShowConfirmDialog(true)
  }

  const confirmDelete = async () => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    try {
      await Promise.all(
        selectedTableData.map(async event => {
          await axios.delete(
            `/api/v1/events/${event.id}/`
          )
        })
      )
      setShowConfirmDialog(false)
      triggerAlert("success", "Events Deleted Successfully")

      setSelectedTableData([])
      const page = Math.floor(first / rows) + 1
      await fetchAllCanlendersList(page)
    } catch (error) {
      triggerAlert("error", getCalendarApiErrorMessage(error, "Failed to delete event."))
    } finally {
      setShowConfirmDialog(false)
    }
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  const [interviewpop, SetInterviewpop] = useState(false)
  const [interview, setInterview] = useState("Interview")
  const [subtype, setSubtype] = useState(null)
  const [startdate, setStartdate] = useState(null)
  const [starttime, setStarttime] = useState(null)
  const [popTextares, setPopTextares] = useState("")
  const [subject, setSubject] = useState("")
  const [priority, setPriority] = useState(null)
  const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
  const [searchText, setSearchText] = useState("")

  const typeInterview = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder, setReminder] = useState(null)
  const reminderOptions = [
    { name: "0 mins", value: "0" },
    { name: "5 mins", value: "5" },
    { name: "10 mins", value: "10" },
    { name: "15 mins", value: "15" },
    { name: "30 mins", value: "30" },
  ]
  const [repeat, setRepeat] = useState(null)
  const repeatOptions = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup, setFollowup] = useState(null)
  const followupOptions = [
    { name: "No", value: "no" },
    { name: "Yes", value: "yes" },
    { name: "1 Day", value: "1day" },
    { name: "2 Days", value: "2days" },
    { name: "3 Days", value: "3days" },
    { name: "1 Week", value: "1week" },
  ]

  const [popchecked, setPopchecked] = useState(false)
  const [popchecked2, setPopchecked2] = useState(false)

  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }

  const [userid, setUserid] = useState([])
  const [uniqueId, setUniqueId] = useState("")
  const customChip = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const typeInterview1 = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder1, setReminder1] = useState(null)
  const reminderOptions1 = [
    { name: "0 mins", value: "0" },
    { name: "5 mins", value: "5" },
    { name: "10 mins", value: "10" },
    { name: "15 mins", value: "15" },
    { name: "30 mins", value: "30" },
  ]
  const [repeat1, setRepeat1] = useState(null)
  const repeatOptions1 = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup1, setFollowup1] = useState(null)
  const followupOptions1 = [
    { name: "None", value: "none" },
    { name: "1 Day", value: "1day" },
    { name: "2 Days", value: "2days" },
    { name: "3 Days", value: "3days" },
    { name: "1 Week", value: "1week" },
    { name: "yes", value: "yes" },
  ]

  const [popcheckedread, setPopcheckedread] = useState(false)
  const [popcheckedread2, setPopcheckedread2] = useState(false)

  const [userid1, setUserid1] = useState(["User1"])
  const customChip1 = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const [defaultDate] = useState(new Date())
  const [interviewpop1, SetInterviewpop1] = useState(false)
  const [interview1, setInterview1] = useState("Interview")
  const [subtype1, setSubtype1] = useState(typeInterview1[1].value)
  const [startdate1, setStartdate1] = useState(defaultDate)
  const [starttime1, setStarttime1] = useState(null)
  const [popTextares1, setPopTextares1] = useState("")
  const [priority1, setPriority1] = useState(null)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [enddate, setEnddate] = useState(null)
  const [endtime, setEndtime] = useState(null)

  // const handleClearSearchCalenderAll = () => {
  //   setFilters({
  //     type: { value: "" },
  //     subtype: { value: "" },
  //     subject: { value: "" },
  //     reminderDate: { value: "" },
  //     startDate: { value: "" },
  //     endDate: { value: "" },
  //     userId: { value: "" },
  //     candidate_name: { value: "" },
  //     recruiter_name: { value: "" },
  //   })
  //   fetchAllCanlendersList(1, rows)
  // }
  const handleClearSearchCalenderAll = () => {
    const clearedFilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      subtype: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      candidate_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      recruiter_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
      reminder: { value: null, matchMode: FilterMatchMode.EQUALS },
      reminderDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
      startDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
      endDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
      completed: { value: null, matchMode: FilterMatchMode.EQUALS },
      private: { value: null, matchMode: FilterMatchMode.EQUALS },
      user_ids: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      archived: { value: null, matchMode: FilterMatchMode.EQUALS },
      auto_followup: { value: null, matchMode: FilterMatchMode.EQUALS },
      calendar_id: { value: null, matchMode: FilterMatchMode.EQUALS },
      candidate_id: { value: null, matchMode: FilterMatchMode.EQUALS },
      contact_id: { value: null, matchMode: FilterMatchMode.EQUALS },
      created_by: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      description: { value: null, matchMode: FilterMatchMode.CONTAINS },
      end_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      event_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
      external_calendar_event_id: {
        value: null,
        matchMode: FilterMatchMode.EQUALS,
      },
      job_id: { value: null, matchMode: FilterMatchMode.EQUALS },
      recurring: { value: null, matchMode: FilterMatchMode.EQUALS },
      reminder_note: { value: null, matchMode: FilterMatchMode.CONTAINS },
      repeat: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      start_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
    };

    setFilters(clearedFilters);
    setIsFilterActive(false);
    fetchAllCanlendersList(1, rows)
  };


  const handleEditClick = async () => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    if (selectedTableData.length !== 1) {
      triggerAlert("error", "Please select exactly one event to edit");
      return;
    }

    const event = selectedTableData[0];
    setSelectedEvent(event);
    setInterview(event.type || "Interview");
    setSubtype(event.subtype || null);
    setStartdate(event.startDate ? new Date(event.startDate) : null);
    setStarttime(
      event.start_time
        ? new Date(`1970-01-01T${event.start_time}Z`)
        : null
    );
    setEnddate(event.endDate ? new Date(event.endDate) : null);
    setEndtime(
      event.end_time ? new Date(`1970-01-01T${event.end_time}Z`) : null
    );

    setPopTextares(event.description || "");
    setScheduleSubtype(schedule.subtype || null);
    setSubject(event.subject || "");
    setPriority(event.event_priority ? event.event_priority.toLowerCase() : null);
    setReminder(event.reminder ? event.reminder.toString().replace("m", "") : null);
    setRepeat(event.repeat ? event.repeat.toLowerCase() : null);
    setFollowup(event.auto_followup ? event.auto_followup.toLowerCase() : null);
    setPopchecked(event.completed || false);
    setPopchecked2(event.private || false);
    setUserid(Array.isArray(event.user_ids) ? event.user_ids : []);

    // Populate job selections with null check
    const jobIds = Array.isArray(event.job_ids) ? event.job_ids : event.job_id ? [event.job_id] : [];
    const matchingJobs = filteredJobslink.filter((job) =>
      jobIds.includes(job.job_id)
    );
    setSelectedJobs(matchingJobs);
    const jobSelections = matchingJobs.map((job) => ({
      name: job.job_title,
      value: job.job_id,
    }));
    setJob(jobSelections.length > 0 ? jobSelections : null);
    setSelectedJobTitles(jobSelections.map((job) => job.name).join(", "));

    // Populate contact selections with null check
    const contactIds = Array.isArray(event.contact_ids) ? event.contact_ids : event.contact_id ? [event.contact_id] : [];
    const matchingContacts = filteredContacts.filter((contact) =>
      contactIds.includes(contact.id)
    );
    setSelectedContacts(matchingContacts);
    const contactSelections = matchingContacts.map((contact) => ({
      name: contact.first_name,
      value: contact.id,
    }));
    setContact(contactSelections.length > 0 ? contactSelections : null);
    setSelectedContactNames(
      contactSelections.map((contact) => contact.name).join(", ")
    );

    // Populate candidate selections with null check
    const candidateIds = getCandidateIds(event.candidate_ids || event.candidate_id);
    let matchingCandidates = filteredCandidates.filter(candidate =>
      candidateIds.includes(candidate.candidate_id)
    );
    // If not found, try to fetch and add
    if (matchingCandidates.length === 0 && candidateIds.length > 0) {
      const fetched = await Promise.all(candidateIds.map(id => ensureCandidateInList(id)));
      matchingCandidates = fetched.filter(Boolean);
    }
    setSelectedCandidates(matchingCandidates);
    const candidateSelections = matchingCandidates.map(candidate => ({
      name: candidate.first_name,
      value: candidate.candidate_id,
    }));
    setCandidate(candidateSelections.length > 0 ? candidateSelections : null);
    setSelectedCandidateNames(
      candidateSelections.map(candidate => candidate.name).join(", ")
    );
    if (schedule.duration) {
      const durationMatch = schedule.duration.match(/(\d+)/);
      const durationMinutes = durationMatch ? parseInt(durationMatch[0], 10) : 30;
      setScheduleDuration(durationMinutes);
    }

    // Ensure uniqueId is populated for Chips component
    setUniqueId(Array.isArray(event.user_ids) ? event.user_ids : []);

    SetInterviewpop(true);
  };

  const handleViewClick = async () => {
    if (selectedTableData.length !== 1) {
      triggerAlert("error", "Please select exactly one event to view");
      return;
    }

    const event = selectedTableData[0];
    setSelectedEvent(event);
    setInterview(event.type || "Interview");
    setSubtype(event.subtype || null);
    setStartdate(event.startDate ? new Date(event.startDate) : null);
    setStarttime(
      event.start_time
        ? new Date(`1970-01-01T${event.start_time}Z`)
        : null
    );
    setEnddate(event.endDate ? new Date(event.endDate) : null);
    setEndtime(
      event.end_time ? new Date(`1970-01-01T${event.end_time}Z`) : null
    );
    setPopTextares(event.description || "");
    setSubject(event.subject || "");
    setPriority(event.event_priority ? event.event_priority.toLowerCase() : null);
    setReminder(event.reminder ? event.reminder.toString().replace("m", "") : null);
    setRepeat(event.repeat ? event.repeat.toLowerCase() : null);
    setFollowup(event.auto_followup ? event.auto_followup.toLowerCase() : null);
    setPopchecked(event.completed || false);
    setPopchecked2(event.private || false);
    setUserid(Array.isArray(event.user_ids) ? event.user_ids : []);

    // Populate job selections with null check
    const jobIds = Array.isArray(event.job_ids) ? event.job_ids : event.job_id ? [event.job_id] : [];
    const matchingJobs = filteredJobslink.filter((job) =>
      jobIds.includes(job.job_id)
    );
    setSelectedJobs(matchingJobs);
    const jobSelections = matchingJobs.map((job) => ({
      name: job.job_title,
      value: job.job_id,
    }));
    setJob(jobSelections.length > 0 ? jobSelections : null);
    setSelectedJobTitles(jobSelections.map((job) => job.name).join(", "));

    // Populate contact selections with null check
    const contactIds = Array.isArray(event.contact_ids) ? event.contact_ids : event.contact_id ? [event.contact_id] : [];
    const matchingContacts = filteredContacts.filter((contact) =>
      contactIds.includes(contact.id)
    );
    setSelectedContacts(matchingContacts);
    const contactSelections = matchingContacts.map((contact) => ({
      name: contact.first_name,
      value: contact.id,
    }));
    setContact(contactSelections.length > 0 ? contactSelections : null);
    setSelectedContactNames(
      contactSelections.map((contact) => contact.name).join(", ")
    );

    // Populate candidate selections with null check
    const candidateIds = getCandidateIds(event.candidate_ids || event.candidate_id);
    let matchingCandidates = filteredCandidates.filter(candidate =>
      candidateIds.includes(candidate.candidate_id)
    );
    // If not found, try to fetch and add
    if (matchingCandidates.length === 0 && candidateIds.length > 0) {
      const fetched = await Promise.all(candidateIds.map(id => ensureCandidateInList(id)));
      matchingCandidates = fetched.filter(Boolean);
    }
    setSelectedCandidates(matchingCandidates);
    const candidateSelections = matchingCandidates.map(candidate => ({
      name: candidate.first_name,
      value: candidate.candidate_id,
    }));
    setCandidate(candidateSelections.length > 0 ? candidateSelections : null);
    setSelectedCandidateNames(
      candidateSelections.map(candidate => candidate.name).join(", ")
    );

    // Ensure uniqueId is populated for Chips component
    setUniqueId(Array.isArray(event.user_ids) ? event.user_ids : []);

    SetInterviewpop1(true);
  };

  const handleSaveTitle = () => {
    const selectedJobTitles = Array.isArray(selectedJobs)
      ? selectedJobs.map(job => job.job_title).join(", ")
      : ""
    setSelectedJobTitles(selectedJobTitles)
    setJob(
      selectedJobs.length > 0
        ? selectedJobs.map(job => ({ name: job.job_title, value: job.job_id }))
        : null
    )
    setSelectedCandidates([])
    setSelectedCandidateNames("")
    setCandidate(null)
    setJobDetailsVisible(false)
    setJobSearchText("")
    setJobFilters({
      job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleRefresh = () => {
    setSelectedJobs([])
    setSelectedJobTitles("")
    setJobSearchText("")
    setJobFilters({
      job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleIconClick = () => {
    setJobDetailsVisible(true)
  }
  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
    if (userInfo && userInfo.user_details) {
      setUniqueId([userInfo.user_details.unique_user_id]);
      console.log("Unique ID set:", [userInfo.user_details.unique_user_id]);
    }
  }, []);


  const handleSave = async () => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    if (!selectedEvent) return;

    const updatedEvent = {
      event_type: interview,
      event_sub_type: subtype,
      subject: subject,
      description: popTextares,
      start_date: startdate ? startdate.toISOString().split("T")[0] : null,
      start_time: starttime ? starttime.toISOString().slice(11, 19) : null,
      end_date: enddate ? enddate.toISOString().split("T")[0] : null,
      end_time: endtime ? endtime.toISOString().slice(11, 19) : null,
      reminder: reminder ? `${reminder}m` : null,
      repeat: repeat ? repeat.charAt(0).toUpperCase() + repeat.slice(1) : null,
      auto_followup: followup ? followup : null,
      completed: popchecked,
      private: popchecked2,
      user_ids: Array.isArray(userid) ? userid : [],
      job_id: Array.isArray(job) ? job.map((j) => j.value) : [],
      candidate_id: Array.isArray(candidate) ? candidate.map((c) => c.value) : [],
      contact_id: Array.isArray(contact) ? contact.map((c) => c.value) : [],
      duration: `${scheduleDuration} Minutes`
    };

    try {
      const response = await axios.put(
        `/api/v1/events/${selectedEvent.calendar_id}/?is_update_flow=true`,
        updatedEvent
      );
      if (response.status === 201 || response.status === 204) {
        triggerAlert("success", "Event Updated Successfully");
        fetchAllCanlendersList(1)
        setTableData((prevData) =>
          prevData.map((item) =>
            item.id === selectedEvent.id
              ? {
                ...item,
                ...updatedEvent,
                created_by_name: item.created_by_name,
                job_id: updatedEvent.job_id,
                candidate_id: updatedEvent.candidate_id,
                contact_id: updatedEvent.contact_id,
              }
              : item
          )
        );
        setSelectedTableData([]);
      } else {
        triggerAlert("error", error);
      }
    } catch (error) {
      triggerAlert("error", getCalendarApiErrorMessage(error, "Failed to update event."));
    } finally {
      SetInterviewpop(false);
    }
  };

  const descriptionBodyTemplate = rowData => {
    const maxLength = 30
    const description = rowData.description || ""
    const isTruncated = description.length > maxLength
    const truncatedText = isTruncated
      ? description.substring(0, maxLength).replace(/\S*$/, "") + "..."
      : description

    const [isExpanded, setIsExpanded] = useState(false)

    const toggleExpand = e => {
      e.stopPropagation()
      setIsExpanded(!isExpanded)
    }

    return (
      <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {isExpanded ? (
          <span>{description}</span>
        ) : (
          <span
            onClick={isTruncated ? toggleExpand : null}
            style={{
              cursor: isTruncated ? "pointer" : "default",
              display: "inline-block",
            }}
            title={isTruncated ? "Click to expand" : ""}
          >
            {truncatedText}
          </span>
        )}
      </div>
    )
  }

  // Handle search input changes
  const handleJobSearch = e => {
    const value = e.target.value
    setJobSearchText(value)
    setJobFilters({
      job_title: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleContactSearch = e => {
    const value = e.target.value
    setContactSearchText(value)
    setContactFilters({
      first_name: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleCandidateSearch = e => {
    const value = e.target.value
    setCandidateSearchText(value)
    setCandidateFilters({
      first_name: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const filteredJobs = filteredJobslink.filter(job =>
    job.job_title?.toLowerCase().includes(jobSearchText.toLowerCase())
  );

  // Filter contacts client-side
  const filteredContactsList = filteredContacts.filter(contact =>
    contact.first_name?.toLowerCase().includes(contactSearchText.toLowerCase())
  );

  // Filter candidates client-side
  const filteredCandidatesList = filteredCandidates.filter(candidate =>
    candidate.first_name?.toLowerCase().includes(candidateSearchText.toLowerCase())
  );

  const handleCompanyChange = (company) => {
    if (company?.company_id) {
      setCompanyId(company?.company_id);
      // fetchUserManagementDetails(company.company_i)
      // getDesignation(company.company_id);
    }
  };
const handleCompanyChange1 = (e) => {
  const id = Number(e.target.value);
  setModalCompanyId(prev => (prev === id ? prev : id));
};

  const [scheduleTypeId, setScheduleTypeId] = useState(null);
  const [interviewTypes, setInterviewTypes] = useState([]);

  const fetchInterviewTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-schedule-type/?interview=true");

      if (response.status === 200) {
        const transformedData = response.data.results.map((type) => ({
          name: type.schedule_type,
          code: type.id,
        }));
        setInterviewTypes(transformedData);
        const interviewType = transformedData.find((t) => t.name === "Interview");
        if (interviewType) {
          setScheduleTypeId(interviewType.code);
        }
      }
    } catch (error) {
      console.error("Error fetching interview types:", error);
    }
  };
  const fetchSubTypes = async (id) => {
    if (!id) return;

    try {
      const response = await axios.get(`/api/v1/get-all-schedule-sub-type/?schedule_id=${id}`);
      const scheduleData = response.data?.results || [];
      const transformedSubTypes = scheduleData.map((schedule) => ({
        name: schedule.schedule_subtype || "Unnamed Sub-Type",
        code: schedule.id || "",
      }));
      setSubTypeCall(transformedSubTypes);
      setScheduleSubtype(null);
    } catch (error) {
      console.error("Error fetching sub-types:", error);
    }
  };

  useEffect(() => {
    fetchInterviewTypes();
  }, []);
  useEffect(() => {
    if (scheduleTypeId) {
      fetchSubTypes(scheduleTypeId);
    }
  }, [scheduleTypeId]);
  const [scheduleCommonPopup, setScheduleCommonPopup] = useState(false);
  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [loadingSave, setLoadingSave] = useState(false)

  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [scheduleSubtype, setScheduleSubtype] = useState(null);
  const [scheduleStartDate, setScheduleStartdate] = useState(new Date());
  const [scheduleStartTime, setScheduleStarttime] = useState(new Date());
  const [scheduleEndDate, setScheduleEndDate] = useState(new Date());
  const [scheduleEndTime, setScheduleEndTime] = useState(new Date());
  const [scheduleSubject, setScheduleSubject] = useState("");
  const [schedulePriority, setSchedulePriority] = useState(null);
  const [schedulepopchecked2, setSchedulePopchecked2] = useState(false);
  const [popchecked1, setPopchecked1] = useState(false);
  const [popTextares2, setPopTextares2] = useState("");
  const [scheduleFormErrors, setScheduleFormErrors] = useState({});
  const [subtypeCall, setSubTypeCall] = useState([]);
  const [selectedScheduleJobs, setSelectedScheduleJobs] = useState([]);
  const [selectedScheduleContacts, setSelectedScheduleContacts] = useState([]);
  const [selectedScheduleCandidates, setSelectedScheduleCandidates] = useState([]);
  const [userid2, setUserid2] = useState([]);
  const [scheduleRepeat, setScheduleRepeat] = useState(null);
  const [scheduleAutoFollowup, setScheduleAutoFollowup] = useState(null);
  const [scheduleReminder, setScheduleReminder] = useState(null);
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [IdforEdit, setIdForEdit] = useState(null);

  const closeSchedulePopup = () => {
    setScheduleCommonPopup(false);
  };
  console.log("selectedScheduleContacts", selectedScheduleContacts.map((c) => c.id))
  const handleSaveSchedule = async () => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    const row = selectedSchedule || {};
    console.log("row", row)
    const payload = {
      event_type: row.event_type || "Interview",
      event_sub_type: scheduleSubtype?.name || row.event_sub_type,
      subject: scheduleSubject || row.subject || "",
      description: popTextares ?? row.description ?? "",

      start_date: scheduleStartDate
        ? new Date(scheduleStartDate).toISOString().split("T")[0]
        : row.start_date,

      start_time: scheduleStartTime
        ? new Date(scheduleStartTime).toLocaleTimeString("en-GB", { hour12: false })
        : row.start_time,

      end_date: scheduleEndDate
        ? new Date(scheduleEndDate).toISOString().split("T")[0]
        : row.end_date,

      end_time: scheduleEndTime
        ? new Date(scheduleEndTime).toLocaleTimeString("en-GB", { hour12: false })
        : row.end_time,

      reminder: scheduleReminder?.value || row.reminder || "10",
      repeat: scheduleRepeat?.value || row.repeat || null,
      auto_followup: scheduleAutoFollowup?.value || row.auto_followup || null,

      completed: typeof popchecked === "boolean" ? popchecked : row.completed ?? false,
      private: typeof schedulepopchecked2 === "boolean" ? schedulepopchecked2 : row.private ?? false,

      user_ids: userid?.length ? userid : row.user_ids || [],

      job_id: selectedScheduleJobs?.length
        ? selectedScheduleJobs.map((j) => j.id)
        : row.job_ids?.map((j) => j.id) || [],

      candidate_id: selectedScheduleCandidates?.length
        ? selectedScheduleCandidates.map((c) => c.id)
        : row.candidate_ids?.map((c) => c.id) || [],

      contact_id: selectedScheduleContacts?.length
        ? selectedScheduleContacts.map(c => (typeof c === "object" ? c.id : c))
        : row.contact_ids?.map(c => (typeof c === "object" ? c.id : c)) || [],


      event_priority: schedulePriority,
      duration: scheduleDuration ? `${scheduleDuration} Minutes` : row.duration || null,
    };
    try {
      setLoadingSave(true);
      if (!row.calendar_id) {
        throw new Error("No calendar_id found for update");
      }
      await axios.put(
        `/api/v1/events/${row.calendar_id}/?is_update_flow=true&company_id=${companyId}`,
        payload
      );
      closeSchedulePopup();
      setErrorAlert(true);
      setIsSuccess(true);
      setErrorMessage("Schedule updated successfully.");
      fetchAllCanlendersList(1, rows);
    } catch (error) {
      console.error("Error updating schedule:", error);
      setErrorAlert(true);
      setIsSuccess(false);
      setErrorMessage("Failed to update schedule.");
    } finally {
      setLoadingSave(false);
    }
  };

  const [showReasonForArchive, setShowReasonForArchive] = useState(false);
  const [archiveReason, setArchiveReason] = useState("");
  const [Archivesaving, setArchivesaving] = useState(false);
  const [CalenderIdToArchive, setCalenderIdToArchive] = useState(null);
  const [ArchiveReasonErr, setArchiveReasonErr] = useState("");
  const handleSaveArchive = async (data) => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    setArchivesaving(true);
    if (!archiveReason) {
      setArchiveReasonErr("Please provide a reason for archiving.");
      setArchivesaving(false);
      return;
    }
    const payload = {
      reason_to_archive: archiveReason,
      calendar_id: CalenderIdToArchive,
    };
    try {
      const response = await axios.post(`/api/v1/events/archive/`, payload);
      setArchivesaving(false);
      setShowReasonForArchive(false);
      setErrorAlert(true);
      setIsSuccess(true)
      setErrorMessage("Calendar archived successfully.");
      fetchAllCanlendersList(1, 10);


    } catch (error) {
      setArchivesaving(false);
      const message = getCalendarApiErrorMessage(error, "Failed to archive calendar.");
      Swal.fire({ icon: "error", title: "Archive failed", text: message, confirmButtonText: "OK" });

    }

  }
  const autoFollowupOptions = [
    { label: "None", value: "" },
    { label: "1 Day", value: "1" },
    { label: "2 Days", value: "2" },
    { label: "3 Days", value: "3" },
  ]
  const reminderOptions2 = [
    { label: "None", value: "" },
    { label: "5 min", value: 5 },
    { label: "10 min", value: 10 },
    { label: "15 min", value: 15 },
    { label: "30 min", value: 30 },
    { label: "1 hour", value: 60 },
  ]
  const handleArchiveClick = (data) => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    console.log(data);
    setCalenderIdToArchive(data.calendar_id);
    setShowReasonForArchive(true);
  };
  const handleEditOnClick = (schedule) => {
    if (isAllCalendarCompany(companyId)) return blockAllCompanyMutation()
    setIdForEdit(schedule.calendar_id);
    setSelectedSchedule(schedule);
    setScheduleFormErrors({});

    const subtypeValue = schedule.event_sub_type || schedule.subtype || "";
    const subtypeObj =
      subtypeCall.find((s) => s.name === subtypeValue || s.code === subtypeValue) ||
      (subtypeValue ? { name: subtypeValue } : null);
    setScheduleSubtype(subtypeObj);

    setScheduleStartdate(schedule.start_date || schedule.startDate ? new Date(schedule.start_date || schedule.startDate) : null);
    setScheduleEndDate(schedule.end_date || schedule.endDate ? new Date(schedule.end_date || schedule.endDate) : null);
    setScheduleStarttime(schedule.start_time ? new Date(`1970-01-01T${schedule.start_time}`) : null);
    setScheduleEndTime(schedule.end_time ? new Date(`1970-01-01T${schedule.end_time}`) : null);

    setScheduleSubject(schedule.subject || "");
    setPopTextares(schedule.description || schedule.body || "");
    setScheduleReminder(schedule.reminder ? { value: schedule.reminder } : null);
    setScheduleRepeat(schedule.repeat ? { value: schedule.repeat } : null);
    setScheduleAutoFollowup(schedule.auto_followup ? { value: schedule.auto_followup } : null);
    setSchedulePriority(schedule.event_priority);
    setPopchecked(Boolean(schedule.completed));
    setSchedulePopchecked2(Boolean(schedule.private));

    setSelectedScheduleJobs(schedule.job_ids?.map((j) => ({ id: j.id, name: j.name })) || []);
    setSelectedScheduleContacts(schedule.contact_ids?.map((ct) => ({ id: ct.id, name: ct.name })) || []);
    setSelectedScheduleCandidates(schedule.candidate_ids?.map((c) => ({ id: c.id, name: c.name })) || []);

    const selected = schedule.contact_ids || [];
    setSelectedEmployees(selected);
    setSelectedContactsLocal(selected);
    setParentContacts(selected.map(e => e.id));

    if (schedule.duration) {
      const durationValue = parseInt(schedule.duration);
      setScheduleDuration(durationValue);
    }

    setScheduleCommonPopup(true);
  };


  const [errorMessage, setErrorMessage] = useState("")
  const [errorAlert, setErrorAlert] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const handleCloseErrorModal = () => setErrorAlert(false)
  const [isFilterActive, setIsFilterActive] = useState(false);
  const InlineLinkCandidate = ({
    onSelectedCandidatesChange,
    error,
    jobId,
    label,
    selectedCandidates,
  }) => {
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [selectedCandidateLocal, setSelectedCandidateLocal] = useState(
      selectedCandidates?.[0] || null
    );
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [jobsCandidates, setJobsCandidates] = useState([]);
    const [totalRecordsCandidates, setTotalRecordsCandidates] = useState(0);
    const [loadingCandidates, setLoadingCandidates] = useState(false);

    // talent scan
    const [talentScanResults, setTalentScanResults] = useState([]);
    const [showTalentScanModal, setShowTalentScanModal] = useState(false);
    const [loadingTalentScanId, setLoadingTalentScanId] = useState(null);

    const getCandidatesForJob = async () => {
      if (!jobId) {
        setJobsCandidates([]);
        setTotalRecordsCandidates(0);
        return;
      }

      setLoadingCandidates(true);
      try {
        const page = lazyParams?.page ?? 0;
        const rowsLocal = lazyParams?.rows ?? 10;
        const response = await axios.get(
          `/api/v1/candidate-jobs/?page=${page + 1}&size=${rowsLocal}&job_id=${jobId}&company_id=${companyId}`
        );
        if (response.status === 200) {
          const transformedData = response.data.results.map((candidate) => ({
            first_name: candidate.name,
            designation: candidate.designation_name,
            current_company: candidate.current_company_name,
            email: candidate.email,
            id: candidate.candidate_id,
            talent_scan_id: candidate.talent_scan_id,
          }));
          setJobsCandidates(transformedData);
          setTotalRecordsCandidates(response.data.count || 0);
        } else {
          setJobsCandidates([]);
          setTotalRecordsCandidates(0);
        }
      } catch (error) {
        console.error("Error fetching candidates for job:", error);
        setJobsCandidates([]);
        setTotalRecordsCandidates(0);
      } finally {
        setLoadingCandidates(false);
      }
    };

    useEffect(() => {
      getCandidatesForJob();

    }, [jobId, lazyParams.page, lazyParams.rows, companyId]);

    const filteredJobs = jobsCandidates.filter(
      (job) =>
        (job?.first_name || "")
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        (job?.designation || "")
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        (job?.email || "").toLowerCase().includes(searchText.toLowerCase()) ||
        (job?.current_company || "").toString().includes(searchText) ||
        (job?.id || "").toString().includes(searchText)
    );

    const onPageChange = (event) => {
      setLazyParams({ page: event.page, rows: event.rows });
    };

    const handleSave = () => {
      const selectedCandidateName = selectedCandidateLocal?.first_name || "";
      onSelectedCandidatesChange?.(selectedCandidateLocal ? [selectedCandidateLocal] : []);
      setJobDetailsVisible(false);
    };

    const handleRefresh = () => {
      setSelectedCandidateLocal(null);
      setSearchText("");
      setLazyParams({ page: 0, rows: lazyParams.rows });
    };

    // fetch talent scan results
    const fetchTalentScanResults = async (talentScanId) => {
      setLoadingTalentScanId(talentScanId);
      try {
        const response = await axios.post(
          `/api/v1/candidate-talent-scan-result/?page=1&size=10&company_id=${companyId}`,
          { talent_scan_id: talentScanId }
        );
        if (response.status === 200) {
          setTalentScanResults(response.data.talent_scan_result.results || []);
          setShowTalentScanModal(true);
        } else {
          setTalentScanResults([]);
        }
      } catch (error) {
        console.error("Error fetching talent scan results:", error);
        setTalentScanResults([]);
      } finally {
        setLoadingTalentScanId(null);
      }
    };

    return (
      <Col lg={6}>
        <div className="field">
          <label htmlFor="job" className="block mb-0">
            {label ? label : "Candidates"}
          </label>
          <div className="d-flex align-items-center" style={{ position: "relative" }}>
            <InputText
              id="job"
              value={selectedCandidateLocal?.first_name || selectedCandidates?.[0]?.name || ""}
              onChange={(e) => { }}
              placeholder="Select Candidates"
              className="w-full"
              style={{ paddingRight: "2rem", cursor: "pointer" }}
              onClick={() => setJobDetailsVisible(true)}
              readOnly
            />
            <i
              className="pi pi-chevron-down"
              onClick={() => setJobDetailsVisible(true)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            ></i>
          </div>

          <Dialog
            header="Link Candidate"
            visible={jobDetailsVisible}
            onHide={() => setJobDetailsVisible(false)}
            style={{ width: "40vw" }}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            className="cand-details"
          >
            <Row>
              <Col lg={12}>
                <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
                  <InputText
                    placeholder="Search Candidates"
                    value={searchText}
                    onInput={(e) => setSearchText(e.target.value)}
                    style={{ paddingRight: "2rem" }}
                  />
                  <i
                    className="pi pi-search"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>
              </Col>
            </Row>
            <div id="CandidateInfo">
            <DataTable
              value={filteredJobs}
              selection={selectedCandidateLocal}
              onSelectionChange={(e) => {
                setSelectedCandidateLocal(e.value);
                // optionally pass selection immediately
                // onSelectedCandidatesChange?.(e.value ? [e.value] : []);
              }}
              dataKey="id"
              size="small"
              lazy
              paginator
              first={lazyParams.page * lazyParams.rows}
              rows={lazyParams.rows}
              totalRecords={totalRecordsCandidates}
              onPage={onPageChange}
              loading={loadingCandidates}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              rowsPerPageOptions={[10, 20, 50, totalRecordsCandidates]}
            >
              <Column selectionMode="single" style={{ width: "3em" }} />
              <Column field="first_name" header="Candidate Name" body={(row) => row.first_name || "–"} />
              <Column field="designation" header="Designation" body={(row) => row.designation || "–"} />
              <Column field="current_company" header="Company" body={(row) => row.current_company || "–"} />
              <Column
                header="Talent Scan"
                body={(rowData) =>
                  rowData.talent_scan_id ? (
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => fetchTalentScanResults(rowData.talent_scan_id)}
                      disabled={loadingTalentScanId === rowData.talent_scan_id}
                    >
                      {loadingTalentScanId === rowData.talent_scan_id && (
                        <span className="pi pi-spinner pi-spin" style={{ marginRight: "8px" }} />
                      )}
                      View Result
                    </button>
                  ) : (
                    "–"
                  )
                }
              />
            </DataTable>
            </div>

            <div className="d-flex mt-3 justify-content-center">
              <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>
                Save
              </button>
              <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>
                Refresh
              </button>
            </div>
          </Dialog>

          <Dialog
            header="Talent Scan Results"
            visible={showTalentScanModal}
            onHide={() => setShowTalentScanModal(false)}
            style={{ width: "60vw" }}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          >
            {talentScanResults?.length > 0 ? (
              talentScanResults.map((result, index) => (
                <div key={index} className="p-3 border rounded mb-3 bg-light">
                  <h5 className="text-primary mb-3">{result?.test_info?.name || "Unnamed Test"}</h5>

                  <Row>
                    <Col md={6}>
                      <h6>🧑 Candidate Info</h6>
                      <p><strong>Name:</strong> {result?.candidate_info?.name}</p>
                      <p><strong>Email:</strong> {result?.candidate_info?.email}</p>
                      <p><strong>Phone:</strong> {result?.candidate_info?.phone}</p>
                      <p><strong>Industry:</strong> {result?.candidate_info?.industry}</p>
                      <p><strong>Experience:</strong> {result?.candidate_info?.experience} yrs</p>
                    </Col>

                    <Col md={6}>
                      <h6>🧾 Test Info</h6>
                      <p><strong>Designation:</strong> {result?.test_info?.test_designation}</p>
                      <p><strong>Skills:</strong> {result?.test_info?.skills?.join(", ")}</p>
                      <p><strong>Attempted:</strong> {result?.is_attempted ? "Yes" : "No"}</p>
                      <p><strong>Link:</strong>{" "}
                        <a href={result?.link} target="_blank" rel="noreferrer">
                          Open Talent Scan
                        </a>
                      </p>
                    </Col>
                  </Row>

                  <h6 className="mt-3">📊 Section Scores</h6>
                  <DataTable value={result?.score_info || []} responsiveLayout="scroll" size="small">
                    <Column field="section__name" header="Section" />
                    <Column field="total_score" header="Total Score" />
                    <Column field="cutoff_score" header="Cutoff" />
                    <Column field="score_secured" header="Score Secured" />
                    <Column field="percentage" header="Percentage" />
                  </DataTable>

                  <h6 className="mt-4">🏁 ATS Summary</h6>
                  <Row>
                    <Col md={4}><strong>Total Score Secured:</strong> {result?.ats_details?.total_score_secured}</Col>
                    <Col md={4}><strong>Actual Total Score:</strong> {result?.ats_details?.actual_total_score}</Col>
                    <Col md={4}><strong>Percentage:</strong> {result?.ats_details?.percentage_score}%</Col>
                  </Row>
                </div>
              ))
            ) : (
              <p>No Talent Scan results found.</p>
            )}
          </Dialog>
        </div>
      </Col>
    );
  };
  const InlineLinkContacts = ({
    onSelectedJobsChange,
    errorJob,
    setSelectedScheduleContacts: setParentContacts,
    errorContact,
    jobLabel,
    selectedJobs,
  }) => {
    // job dialog
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [searchTextJobs, setSearchTextJobs] = useState("");
    const [selectedJobLocal, setSelectedJobLocal] = useState(
      selectedJobs?.[0] || null
    );
    const [lazyParamsJobs, setLazyParamsJobs] = useState({ page: 0, rows: 10 });
    const [jobs, setJobs] = useState([]);
    const [totalRecordsJobs, setTotalRecordsJobs] = useState(0);
    const [loadingJobs, setLoadingJobs] = useState(false);

    // employees multiselect
    const [priorityContactOptions, setPriorityContactOptions] = useState([]);
    const [loadingContacts, setLoadingContacts] = useState(true);


    // contact dialog (multi)
    const [dialogVisible, setDialogVisible] = useState(false);


    // fetch jobs (active approved/open)
    const getAllActiveJobs = async () => {
      setLoadingJobs(true);
      try {
        const page = lazyParamsJobs?.page ?? 0;
        const rows = lazyParamsJobs?.rows ?? 10;
        const response = await axios.get(
          `/api/v1/jobs/?page=${page + 1}&size=${rows}&status=Approved / Open&company_id=${companyId}`
        );
        if (response.status === 200) {
          const transformedData = response.data.results.map((cond) => ({
            title: cond.job_title,
            id: cond.job_id,
            manager: cond.hiring_manager_name,
            job_number: cond.job_number,
            name: cond.job_title,
          }));
          setJobs(transformedData);
          setTotalRecordsJobs(response.data.count || 0);
        } else {
          setJobs([]);
          setTotalRecordsJobs(0);
        }
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setJobs([]);
        setTotalRecordsJobs(0);
      } finally {
        setLoadingJobs(false);
      }
    };

    useEffect(() => {
      getAllActiveJobs();

    }, [lazyParamsJobs.page, lazyParamsJobs.rows, companyId]);


    // fetch contacts / recruiters for company
    const getAllActiveContacts = async () => {
      setLoadingContacts(true);
      try {
        const response = await axios.get(
          `/api/v1/get-all-recruiters/?company_id=${companyId}`
        );
        // response.data assumed to be array of users
        const transformedData = (response.data || []).map((contact) => ({
          // name: contact?.first_name || contact?.name || "Unnamed",
          name: `${contact?.first_name} ${contact?.middle_name} ${contact?.last_name}`,
          id: contact?.id,
        }));
        setPriorityContactOptions(transformedData);
      } catch (error) {
        console.error("Error fetching contacts:", error);
        setPriorityContactOptions([]);
      } finally {
        setLoadingContacts(false);
      }
    };

    useEffect(() => {
      if (companyId) getAllActiveContacts();
    }, [companyId]);

    const filteredJobs = (dataList) =>
      dataList.filter(
        (job) =>
          (job.title || "")
            .toString()
            .toLowerCase()
            .includes(searchTextJobs.toLowerCase()) ||
          (job.manager || "")
            .toString()
            .toLowerCase()
            .includes(searchTextJobs.toLowerCase()) ||
          (job.job_number || "")
            .toString()
            .toLowerCase()
            .includes(searchTextJobs.toLowerCase()) ||
          (job.id || "").toString().includes(searchTextJobs)
      );

    const onPageChangeJobs = (event) => {
      setLazyParamsJobs({ page: event.page, rows: event.rows });
    };

    const handleSaveJob = () => {
      setJobDetailsVisible(false);
      onSelectedJobsChange?.(selectedJobLocal ? [selectedJobLocal] : []);
    };

    const handleRefreshJobs = () => {
      setSelectedJobLocal(null);
      setSearchTextJobs("");
      setLazyParamsJobs({ page: 0, rows: lazyParamsJobs.rows });
    };

    const handleOpenContactDialog = () => {
      setDialogVisible(true);
    };
    const closeDialogContact = () => {
      setDialogVisible(false);
    };

    const handleSaveContact = () => {
      const selectedIds = selectedContactsLocal.map((c) => c.id);
      // set priority contact string locally if needed
      setParentContacts(selectedIds);
      setDialogVisible(false);
    };

    return (
      <>
        <Col lg={6}>
          <div className="field">
            <label htmlFor="job" className="block">
              {jobLabel || <span>Jobs</span>}
            </label>
            <div
              className="d-flex align-items-center"
              style={{ position: "relative" }}
            >
              <InputText
                id="job"
                value={
                  selectedJobLocal
                    ? `${selectedJobLocal.title || selectedJobLocal.name}, ${selectedJobLocal.job_number || selectedJobLocal.id
                    }`
                    : selectedJobs?.[0]?.name || ""
                }
                placeholder="Select Job"
                className="w-full"
                onClick={() => setJobDetailsVisible(true)}
                style={{ paddingRight: "2rem", cursor: "pointer" }}
                readOnly
              />
              <i
                className="pi pi-chevron-down"
                onClick={() => setJobDetailsVisible(true)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              ></i>
            </div>

            <Dialog
              header="Link Jobs"
              visible={jobDetailsVisible}
              onHide={() => setJobDetailsVisible(false)}
              style={{ width: "40vw" }}
              breakpoints={{ "960px": "75vw", "641px": "100vw" }}
              className="cand-details"
            >
              <Row>
                <Col lg={12}>
                  <div
                    className="p-inputgroup mb-3"
                    style={{ position: "relative" }}
                  >
                    <InputText
                      placeholder="Search Jobs"
                      value={searchTextJobs}
                      onInput={(e) => setSearchTextJobs(e.target.value)}
                      style={{ paddingRight: "2rem" }}
                    />
                    <i
                      className="pi pi-search"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "49%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                  </div>
                </Col>
              </Row>
              <div id="JobTableView">
              <DataTable
                value={filteredJobs(jobs)}
                selection={selectedJobLocal}
                onSelectionChange={(e) => setSelectedJobLocal(e.value)}
                dataKey="id"
                size="small"
                lazy
                paginator
                first={lazyParamsJobs.page * lazyParamsJobs.rows}
                rows={lazyParamsJobs.rows}
                totalRecords={totalRecordsJobs}
                onPage={onPageChangeJobs}
                loading={loadingJobs}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                rowsPerPageOptions={[10, 20, 50, totalRecordsJobs]}
              >
                <Column selectionMode="single" style={{ width: "3em" }} />
                <Column field="job_number" header="Job ID" />
                <Column field="title" header="Job Title" />
                <Column field="handled_by" header="Contact" />
              </DataTable>
              </div>

              <div className="d-flex mt-3 justify-content-center">
                <button
                  type="button"
                  className="btn btn-primary me-2 btn-main"
                  onClick={handleSaveJob}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-main"
                  onClick={handleRefreshJobs}
                >
                  Refresh
                </button>
              </div>
            </Dialog>

            {errorJob && <p style={{ color: "red" }}>{errorJob}</p>}
          </div>
        </Col>

        <Col xl={6}>
          <div className="p-field flex flex-column">
            <label htmlFor="contact" className="block">
              Interviewer
            </label>
            <div
              className="d-flex align-items-center"
              style={{ position: "relative" }}
            >
              <MultiSelect
                id="company"
                value={selectedEmployees}
                options={priorityContactOptions}
                onChange={(e) => {
                  setSelectedEmployees(e.value);
                  const selectedIds = e.value.map((item) => item.id);
                  setParentContacts(selectedIds);
                }}
                placeholder="Select Interviewer"
                optionLabel="name"
                filter
                filterBy="name"
                display="comma"
                className="w-full activejobdrop border"
                loading={loadingContacts}
              />
            </div>
            {errorContact && <p style={{ color: "red" }}>{errorContact}</p>}

            <Dialog
              header="Select Contacts"
              visible={dialogVisible}
              onHide={closeDialogContact}
              style={{ width: "40vw" }}
              breakpoints={{ "960px": "75vw", "641px": "100vw" }}
              className="cand-details"
            >
              <Col lg={12}>
                <div
                  className="p-inputgroup mb-3"
                  style={{ position: "relative" }}
                >
                  <InputText
                    placeholder="Search Contacts"
                    value={""}
                    onInput={() => { }}
                    style={{ paddingRight: "2rem" }}
                  />
                  <i
                    className="pi pi-search"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "49%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>
              </Col>

              <DataTable
                value={priorityContactOptions}
                paginator
                rows={5}
                selection={selectedContactsLocal}
                onSelectionChange={(e) => setSelectedContactsLocal(e.value)}
                dataKey="id"
                rowsPerPageOptions={[5, 10, 25]}
                size="small"
              >
                <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />
                <Column field="name" header="Contact Name" />
              </DataTable>

              <div className="d-flex mt-3">
                <button
                  type="button"
                  className="btn btn-primary me-2 btn-main"
                  onClick={handleSaveContact}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-main"
                  onClick={closeDialogContact}
                >
                  Cancel
                </button>
              </div>
            </Dialog>
          </div>
        </Col>
      </>
    );
  };
const formatTime = (timeString) => {
  if (!timeString || typeof timeString !== "string") return "-";
  const parts = timeString.split(":");
  if (parts.length < 2) return "-";
  const [hours, minutes] = parts;
  if (Number.isNaN(Number(hours)) || Number.isNaN(Number(minutes))) return "-";
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
const formatInterviewDate = (dateString) => {
  if (!dateString) return "-";
  const [year, month, day] = String(dateString).split("T")[0].split("-");
  if (!year || !month || !day) return "-";
  return `${day}-${month}-${year}`;
};
  return (
    <React.Fragment>
      <div className="page-content allact-tabs calendar-module-page">
        <Container fluid={true}>
          <div className="page-title-box actjobbread mb-0 calendar-module-shell">
            <Row className="align-items-center pt-3 pb-3 breadcrumb-card action-items  bg-white">
              <Col md={6} lg={4} className="d-flex align-items-center">
                <h1 className="page-title mb-1">All Interviews</h1>
                {/* {selectedTableData.length > 0 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn ms-1 mainbtn me-1"
                    >
                      <i className="fa-regular fa-user me-1"></i>{" "}
                      {selectedTableData.length} selected
                    </button>
                    <div className="action-icons me-2">
                      {viewPermission && (
                        <>
                          {selectedTableData.length >= 2 ? (
                            ""
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1"
                              onClick={handleViewClick}
                            >
                              <i className="pi pi-eye"></i>
                            </button>
                          )}
                        </>
                      )}

                      {editPermission && (
                        <>
                          {selectedTableData.length >= 2 ? (
                            ""
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 edit"
                              onClick={handleEditClick}
                            >
                              <i className="pi pi-pencil"></i>
                            </button>
                          )}
                        </>
                      )}

                      {deletePermission && (
                        <>
                          <button
                            type="button"
                            className="btn btn-secondary icons-btn ms-1 delete"
                            onClick={handleDeleteSelected}
                          >
                            <i className="pi pi-trash"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </>
                )}
                {isFilterActive && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn ms-1 mainbtn mb-1"
                      onClick={handleClearSearchCalenderAll}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear Search
                    </button>
                  </div>)} */}
              </Col>
              <Col lg={8} md={12} className="mt-2">
                  <div className="d-flex align-items-center justify-content-end">
                    <label className="me-2" style={{marginTop: "-10px"}}>Select Company</label>
                    <div style={{ width: "170px" }}>
                      <CompanySelector onCompanyChange={handleCompanyChange} onCompaniesLoaded={handleCompaniesLoaded} />
                    </div>
                </div>
              </Col>

            </Row>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
                <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
              </div>
            ) : (
              <Row>
                <Col lg={12}>
                  <section className="job-datatable-section">
                    <div className="card1 mt-2 mb-4 actjobsumtable datatable-check calendar-module-card" id="CalendarScheduled_TableView">
                      <DataTable
                        ref={dt}
                        value={processedData}
                        paginator
                        lazy={true}
                        id="AllEmployees_TableView"
                        tableStyle={{
                          width: "100%",
                          tableLayout: "fixed",
                          borderRadius: "8px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                        rows={rows}
                        first={first}
                        totalRecords={totalRecords}
                        // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        onPage={onPage}
                        onFilter={onFilter}
                        dataKey="id"
                        loading={loading}
                        scrollable
                        // scrollHeight="550px"
                        emptyMessage="No records found."
                        rowsPerPageOptions={[10, 20, 30, 50, totalRecords]}
                        // selection={selectedTableData}
                        // onSelectionChange={e => setSelectedTableData(e.value)}
                        // filters={filters}
                        // filterDisplay="row"
                        reorderableRows
                        // resizableColumns
                        // columnResizeMode="expand"
                        pagination
                      // lazy
                      // onRowClick={e => setSelectedTableData([e.data])}
                      >
                        {/* <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        /> */}
                        {/* <Column
                        field="type"
                        header="Type"
                        sortable
                        filter
                        style={{ minWidth: "10rem" }}
                      /> */}
                        <Column
                          field="subtype"
                          header="Interview Type"
                          // sortable
                          // filter
                          // filterPlaceholder="Interview Type"
                          style={{ width: "8.5rem" }}
                          body={(rowData) => <span title={rowData.subtype || "-"}>{rowData.subtype}</span>}
                        />
                       <Column
                            header="Interview Date & Time"
                            style={{ width: "8rem" }}
                            // filter
                            // filterPlaceholder="Interview Time"
                            body={(rowData) => {
                              const interviewDate = rowData.selected_date ? formatInterviewDate(rowData.selected_date) : "-";
                              const startTime = rowData.start_time ? formatTime(rowData.start_time) : "-";
                              const endTime = rowData.end_time ? formatTime(rowData.end_time) : "-";
                              const title = `${interviewDate} ${startTime} - ${endTime}`;
                              return (
                                <div title={title}>
                                  <div style={{ cursor: "pointer"}}>{interviewDate}</div>
                                  <div style={{ cursor: "pointer"}}>{startTime} - {endTime}</div>
                                </div>
                              );
                            }}
                          />

                        <Column
                        field="meeting_link"
                        header="Meeting Link"
                        // sortable
                        // filter
                        // filterPlaceholder="Meeting Link"
                        style={{ width: "9rem" }}
                        body={(rowData) => {
                          const meetingLink = rowData.meeting_link || "N/A";
                          const participantLink = rowData.participant_link ;
                          // const googleMeetLink = rowData.google_calendar_link || "N/A";

                          return meetingLink === "N/A" ? (
                            "N/A"
                          ) : (
                            <>
                            <span title="Open meeting link">
                            <a
                            href={meetingLink}
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                              width: 32,
                              height: 32,
                              borderRadius: 6,
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#eef6ff",
                              border: "1px solid #d4e7fb",
                              color: "#1a5fa8",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                            // title="Click here to Copy Link"
                            // onClick={(e) => {
                            //   e.preventDefault(); 
                            //   navigator.clipboard.writeText(meetingLink).then(() => {
                            //     Swal.fire({
                            //       icon: "success",
                            //       title: "Meeting Link Copied!",
                            //       text: "Copied Successfully!",
                            //       confirmButtonText: "Open Link",
                            //       showCloseButton: true,   
                            //     }).then((result) => {
                            //       if (result.isConfirmed) {
                            //         window.open(meetingLink, "_blank", "noopener,noreferrer");
                            //       }
                            //     });
                            //   }).catch(() => {
                            //     Swal.fire({
                            //       icon: "error",
                            //       title: "Error",
                            //       text: "Unable to copy meeting link.",
                            //     });
                            //   });
                            // }}
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(meetingLink, "_blank", "noopener,noreferrer");
                              }}
                              title="Open meeting link"
                            >
                            <i className="fa fa-video-camera" aria-hidden="true" style={{ fontSize: "12px" }}></i>
                          </a>
                        </span>
                          <span title={!participantLink ? "No link to copy" : "Copy Meeting Link"}>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary ms-1"
                            // title="Copy Meeting Link"
                            disabled={!participantLink}
                            onClick={() => {
                              navigator.clipboard.writeText(participantLink).then(() => {
                                Swal.fire({
                                  icon: "success",
                                  title: "Copied!",
                                  text: "Meeting link copied successfully.",
                                  timer: 1500,
                                  showConfirmButton: false,
                                });
                              }).catch(() => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Error",
                                  text: "Unable to copy meeting link.",
                                });
                              });
                            }}
                          >
                            <i className="fa fa-clone" aria-hidden="true" style={{ fontSize: "12px"}}></i>
                          </button>
                        </span>
                        <span title="Share Meeting Link">
                           <button
                            type="button"
                            className="btn btn-sm btn-primary ms-1"
                            onClick={() => handleShareClick(rowData)}
                            title="Share Meeting Link"
                          >
                            <i className="fa fa-share-alt"  style={{ fontSize: "12px"}}></i>
                          </button>
                        </span>
                              </>
                          );
                        }}
                      />
                        <Column
                          header="Job"
                          style={{ width: "7.5rem" }}
                          body={(row) => {
                            const jobTitle = row.job_ids?.[0]?.name || "-";
                            return <span title={jobTitle}>{jobTitle}</span>;
                          }}
                          // filter
                          // filterField="job"
                          // filterPlaceholder="Job"
                          // sortable
                        />
                        <Column
                          field="subject"
                          header="Subject"
                          // sortable
                          // filter
                          // filterPlaceholder="Subject"
                          style={{ width: "10rem" }}
                          body={(rowData) => <span title={rowData.subject || "-"}>{rowData.subject || "-"}</span>}
                        />
                        <Column
                          field="created_by_name"
                          header="Created By"
                          style={{ width: "9rem" }}
                          body={(rowData) => <span title={rowData.created_by_name || "-"}>{rowData.created_by_name || "-"}</span>}
                          // sortable
                          // filter
                          // filterField="created_by_name"
                          // filterPlaceholder="Created By"
                        />
                        {/* <Column
                        field="reminder"
                        header="Reminder"
                        sortable
                        filter
                        style={{ minWidth: "8rem" }}
                        body={reminderTemplate}
                        className="d-none"
                      /> */}
                        {/* <Column
                        field="reminderDate"
                        header="Reminder Date"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      /> */}
                        {/* <Column
                          field="startDate"
                          header="Start Date"
                          sortable
                          filter
                          filterPlaceholder="Start Date"
                          style={{ width: "12rem" }}
                          body={(rowData) => <span>{formatDate(rowData.startDate)}</span>}
                          className="d-none"
                        />
                        <Column
                          field="start_time"
                          header="Time"
                          sortable
                          filter
                          filterField="start_time"
                          filterPlaceholder="Time"
                          className="d-none"
                        /> */}
                        {/* <Column
                          field="endDate"
                          header="End Date"
                          sortable
                          filter
                          filterPlaceholder="End Date"
                          style={{ width: "11rem" }}
                          body={(rowData) => <span>{formatDate(rowData.endDate)}</span>}
                        /> */}
                        <Column
                          field="recruiter_name"
                          header="Recruiter Name"
                          // sortable
                          // filter
                          // filterPlaceholder="Recruiter Name"
                          style={{ width: "10.5rem" }}
                          body={(rowData) => {
                            const contactNames = rowData.contact_ids?.map(contact => contact.name) || [];
                            const displayedNames = contactNames.slice(0, 2).join(", ");
                            const allNames = contactNames.join(", ");

                            return (
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  maxWidth: "200px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={allNames}
                              >
                                {contactNames.length > 2 ? `${displayedNames}, ...` : displayedNames}
                              </div>
                            );
                          }}

                        />
                        <Column
                          field="candidate_name"
                          header="Candidate Name"
                          // sortable
                          // filter
                          // filterPlaceholder="Candidate Name"
                          style={{ width: "10rem" }}
                          body={(rowData) => {
                            const candidateName = getCandidateNames(rowData.candidate_ids);
                            return <span title={candidateName}>{candidateName}</span>;
                          }}
                        />
                        {/* <Column
                          field="Duration"
                          header="Duration"
                          sortable
                          filter
                          filterPlaceholder="Duration"
                          style={{ minWidth: "12rem" }}
                          body={(rowData) => rowData.duration}
                        /> */}
                        <Column
                          field="event_priority"
                          header="Priority"
                          // sortable
                          // filter
                          // filterPlaceholder="Priority"
                          //   body={rowData => (
                          //   <span style={{ color: rowData.event_priority === 'Low' ? 'green' : rowData.event_priority === 'medium' ? 'orange' : rowData.event_priority === 'high' ? 'red' : 'gray' }}>
                          //     {rowData.event_priority}
                          //   </span>
                          // )}
                          body={(rowData) => {
                            const v = (rowData.event_priority || "").toString().toLowerCase();
                            const color =
                              v === "low" ? "green" :
                                v === "medium" ? "orange" :
                                  v === "high" ? "red" : "gray";

                            return (
                              <span style={{ color }}>
                                {rowData.event_priority}
                              </span>
                            );
                          }}
                          style={{ width: "5.5rem" }}
                        />
                        {/* <Column
                        field="private"
                        header="Private"
                        body={privateCheckboxTemplate}
                        style={{ minWidth: "8rem" }}
                      />  */}
                        {/* <Column className="d-none"
  field="user_ids"
  header="User ID"
  sortable
  filter
  style={{ minWidth: "10rem" }}
  body={rowData => (
    <span>
      {Array.isArray(rowData.user_ids) && rowData.user_ids.length > 0
        ? rowData.user_ids.join(", ")
        : "None"}
    </span>
  )}
/> */}
                        <Column
                          header="Actions"
                          style={{ width: "6rem", textAlign: "center" }}
                          body={(rowData) => {
                            const googleMeetLink = rowData.google_calendar_link;
                            return(
                            <div className="d-flex justify-content-center align-items-center">
                              {/* Edit button */}
                              <button
                                type="button"
                                className="btn btn-sm btn-default border icons-btn ms-1 edit"
                                onClick={() => handleEditOnClick(rowData)}
                                title="Edit"
                              >
                                <i className="pi pi-pencil"></i>
                              </button>

                              {/* Archive button */}
                              <button
                                type="button"
                                className="btn btn-sm btn-default border icons-btn ms-1 archive"
                                onClick={() => handleArchiveClick(rowData)}
                                title="Archive"
                              >
                                <i className="pi pi-box"></i>
                              </button>
                             <button
                              type="button"
                              className="btn btn-sm btn-default border icons-btn ms-1"
                              title="Add to Calendar"
                              disabled={!rowData.google_calendar_link}
                              onClick={() => window.open(googleMeetLink, "_blank")}
                            >
                              <i className="fa fa-calendar" aria-hidden="true"></i>
                            </button>

                            </div>
                            )}}
                          // )}
                        />
                      </DataTable>

                      <Dialog
                        visible={showConfirmDialog}
                        style={{ width: "450px" }}
                        header="Confirm Deletion"
                        modal
                        footer={
                          <div>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={cancelDelete}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger ms-2"
                              onClick={confirmDelete}
                            >
                              Delete
                            </button>
                          </div>
                        }
                        onHide={() => setShowConfirmDialog(false)}
                      >
                        <p>
                          Are you sure you want to delete{" "}
                          <strong>{selectedTableData[0]?.type}</strong>?
                        </p>
                      </Dialog>

                      <div className="card flex justify-content-center">
                        <Dialog
                          header={`APPOINTMENT${selectedEvent?.created_by_name
                            ? " - " + selectedEvent.created_by_name
                            : ""
                            }`}
                          visible={interviewpop}
                          className="interview-popup"
                          style={{ width: "50vw" }}
                          onHide={() => {
                            if (!interviewpop) return
                            SetInterviewpop(false)
                          }}
                        >
                          <p className="bg-form calendar-event-edit-form">
                            <div className="mb-4">
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="interview">Type</label>
                                    <InputText
                                      id="interview"
                                      aria-describedby="username-help"
                                      value={interview}
                                      placeholder="Interview"
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="integer" className=" block">
                                      Sub-Type
                                    </label>
                                    <InputText
                                      id="integer"
                                      value={subtype}
                                      onChange={e => setSubtype(e.target.value)}
                                      placeholder="Subtype"
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6}>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field flex-auto">
                                        <label
                                          htmlFor="buttondisplay"
                                          className="block"
                                        >
                                          Start date
                                        </label>
                                        <Calendar
                                          value={startdate}
                                          onChange={e => setStartdate(e.value)}
                                          showIcon
                                          dateFormat="yy-mm-dd"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex-auto">
                                        <label
                                          htmlFor="buttondisplay"
                                          className="block"
                                        >
                                          Time
                                        </label>
                                        <Calendar
                                          value={starttime}
                                          onChange={e => setStarttime(e.value)}
                                          showIcon
                                          timeOnly
                                          icon={() => (
                                            <i className="pi pi-clock" />
                                          )}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xl={6}>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="flex-auto">
                                        <label
                                          htmlFor="buttondisplay"
                                          className="block"
                                        >
                                          End date
                                        </label>
                                        <Calendar
                                          value={enddate}
                                          onChange={e => setEnddate(e.value)}
                                          showIcon
                                          dateFormat="yy-mm-dd"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="flex-auto">
                                        <label
                                          htmlFor="buttondisplay"
                                          className="block"
                                        >
                                          Time
                                        </label>
                                        <Calendar
                                          value={endtime}
                                          onChange={e => setEndtime(e.value)}
                                          showIcon
                                          timeOnly
                                          icon={() => (
                                            <i className="pi pi-clock" />
                                          )}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                            <div className="mb-4">
                              <Row className="mb-2">
                                <Col lg={6}>
                                  <div className="field">
                                    <label htmlFor="job" className="block mb-0">
                                      Job
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="job"
                                        value={selectedJobTitles}
                                        onChange={e =>
                                          setSelectedJobTitles(e.target.value)
                                        }
                                        placeholder="Enter Job"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        readOnly
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        onClick={handleIconClick}
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                        }}
                                      ></i>
                                    </div>
                                    <Dialog
                                      header="Job Details"
                                      visible={jobDetailsVisible}
                                      onHide={() => setJobDetailsVisible(false)}
                                      style={{ width: "40vw" }}
                                      breakpoints={{
                                        "960px": "75vw",
                                        "641px": "100vw",
                                      }}
                                      className="cand-details"
                                    >
                                      <Row>
                                        <Col lg={12}>
                                          <div
                                            className="p-inputgroup mb-3"
                                            style={{ position: "relative" }}
                                          >
                                            <InputText
                                              placeholder="Search Jobs"
                                              value={jobSearchText}
                                              onInput={handleJobSearch}
                                              style={{ paddingRight: "2rem" }}
                                            />
                                            <i
                                              className="pi pi-search"
                                              style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "49%",
                                                transform: "translateY(-50%)",
                                              }}
                                            ></i>
                                          </div>
                                        </Col>
                                      </Row>
                                      <DataTable
                                        value={filteredJobs}
                                        paginator
                                        first={jobLazyParams.page * jobLazyParams.rows}
                                        rows={jobLazyParams.rows}
                                        totalRecords={totalRecordsJobs}
                                        onPage={onJobPageChange}
                                        // selection={selectedJobs}
                                        // onSelectionChange={e =>
                                        //   setSelectedJobs(e.value || [])
                                        // }
                                        lazy
                                        dataKey="job_id"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        size="small"
                                        filters={jobFilters}
                                        filterDisplay="row"
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                      >
                                        {/* <Column
                                          selectionMode="multiple"
                                          style={{ width: "3em" }}
                                        /> */}

                                        <Column
                                          field="job_title"
                                          header="Job Title"
                                        />
                                        <Column
                                          field="hiring_manager_name"
                                          header="Contact"
                                        />
                                      </DataTable>
                                      <div className="d-flex mt-3">
                                        <button
                                          type="button"
                                          className="btn btn-primary me-2 btn-main"
                                          onClick={handleSaveTitle}
                                        >
                                          Oks
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-main"
                                          onClick={handleRefresh}
                                        >
                                          Refresh
                                        </button>
                                      </div>
                                    </Dialog>
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="field">
                                    <label
                                      htmlFor="contact"
                                      className="block mb-0"
                                    >
                                      Contact
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="contact"
                                        value={selectedContactNames}
                                        onChange={e =>
                                          setSelectedContactNames(e.target.value)
                                        }
                                        placeholder="Enter Contact"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        readOnly
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        onClick={handleContactIconClick}
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                        }}
                                      ></i>
                                    </div>
                                    <Dialog
                                      header="Contact Details"
                                      visible={contactDetailsVisible}
                                      onHide={() =>
                                        setContactDetailsVisible(false)
                                      }
                                      style={{ width: "40vw" }}
                                      breakpoints={{
                                        "960px": "75vw",
                                        "641px": "100vw",
                                      }}
                                      className="contact-details"
                                    >
                                      <Row>
                                        <Col lg={12}>
                                          <div
                                            className="p-inputgroup mb-3"
                                            style={{ position: "relative" }}
                                          >
                                            <InputText
                                              placeholder="Search Contacts"
                                              value={contactSearchText}
                                              onInput={handleContactSearch}
                                              style={{ paddingRight: "2rem" }}
                                            />
                                            <i
                                              className="pi pi-search"
                                              style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "49%",
                                                transform: "translateY(-50%)",
                                              }}
                                            ></i>
                                          </div>
                                        </Col>
                                      </Row>
                                      <DataTable
                                        value={filteredContactsList}
                                        paginator
                                        first={contactLazyParams.page * contactLazyParams.rows}
                                        rows={contactLazyParams.rows}
                                        totalRecords={totalRecordsContacts}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        onPage={onContactPageChange}
                                        // selection={selectedContacts}
                                        // onSelectionChange={e =>
                                        //   setSelectedContacts(e.value || [])
                                        // }
                                        dataKey="id"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        size="small"
                                        filters={contactFilters}
                                        filterDisplay="row"
                                        lazy
                                      >
                                        {/* <Column
                                          selectionMode="multiple"
                                          style={{ width: "3em" }}
                                        /> */}

                                        <Column
                                          field="first_name"
                                          header="Contact Name"
                                        />
                                        <Column field="email" header="Email" />
                                      </DataTable>
                                      <div className="d-flex mt-3">
                                        <button
                                          type="button"
                                          className="btn btn-primary me-2 btn-main"
                                          onClick={handleSaveContact}
                                        >
                                          Ok
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-main"
                                          onClick={handleContactRefresh}
                                        >
                                          Refresh
                                        </button>
                                      </div>
                                    </Dialog>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="field">
                                    <label
                                      htmlFor="candidate"
                                      className="block mb-0"
                                    >
                                      Candidate
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="candidate"
                                        value={selectedCandidateNames}
                                        onChange={e =>
                                          setSelectedCandidateNames(
                                            e.target.value
                                          )
                                        }
                                        placeholder="Enter Candidate"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        readOnly
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        onClick={handleCandidateIconClick}
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                        }}
                                      ></i>
                                    </div>
                                    <Dialog
                                      header="Candidate Details"
                                      visible={candidateDetailsVisible}
                                      onHide={() =>
                                        setCandidateDetailsVisible(false)
                                      }
                                      style={{ width: "40vw" }}
                                      breakpoints={{
                                        "960px": "75vw",
                                        "641px": "100vw",
                                      }}
                                      className="candidate-details"
                                    >
                                      <Row>
                                        <Col lg={12}>
                                          <div
                                            className="p-inputgroup mb-3"
                                            style={{ position: "relative" }}
                                          >
                                            <InputText
                                              placeholder="Search Candidates"
                                              value={candidateSearchText}
                                              onInput={handleCandidateSearch}
                                              style={{ paddingRight: "2rem" }}
                                            />
                                            <i
                                              className="pi pi-search"
                                              style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "49%",
                                                transform: "translateY(-50%)",
                                              }}
                                            ></i>
                                          </div>
                                        </Col>
                                      </Row>
                                      <DataTable
                                        value={filteredCandidatesList}
                                        paginator
                                        first={candidateLazyParams.page * candidateLazyParams.rows}
                                        rows={candidateLazyParams.rows}
                                        totalRecords={totalRecordsCandidates}
                                        // selection={selectedCandidates}
                                        // onSelectionChange={e =>
                                        //   setSelectedCandidates(e.value || [])
                                        // }
                                        dataKey="candidate_id"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        size="small"
                                        filters={candidateFilters}
                                        filterDisplay="row"
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        onPage={onCandidatePageChange}
                                        lazy
                                      >
                                        {/* <Column
                                          selectionMode="multiple"
                                          style={{ width: "3em" }}
                                        /> */}
                                        {/* <Column
                                        field="candidate_id"
                                        header="Candidate ID"
                                      /> */}
                                        <Column
                                          field="first_name"
                                          header="Candidate Name"
                                        />
                                        <Column field="email" header="Email" />
                                      </DataTable>
                                      <div className="d-flex mt-3">
                                        <button
                                          type="button"
                                          className="btn btn-primary me-2 btn-main"
                                          onClick={handleSaveCandidate}
                                        >
                                          Ok
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-main"
                                          onClick={handleCandidateRefresh}
                                        >
                                          Refresh
                                        </button>
                                      </div>
                                    </Dialog>
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="subject">Subject</label>
                                    <InputText
                                      id="subject"
                                      onChange={e => setSubject(e.target.value)}
                                      value={subject}
                                      placeholder="Subject"
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2 mt-3">
                                <Col xl={12}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="description">
                                      Description
                                    </label>
                                    <InputTextarea
                                      id="description"
                                      className="w-full"
                                      value={popTextares}
                                      onChange={e =>
                                        setPopTextares(e.target.value)
                                      }
                                      placeholder="Interview Test"
                                      rows={3}
                                      cols={20}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div>
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="p-field">
                                    <label htmlFor="username">
                                      Auto Followup
                                    </label>
                                    <Dropdown
                                      value={followup}
                                      onChange={e => setFollowup(e.value)}
                                      options={followupOptions}
                                      optionLabel="name"
                                      placeholder="Select a Followup Interval"
                                      className="w-full search-option"
                                    />
                                  </div>
                                </Col>
                                {/* <Col xl={6}>
                                  <Row>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="username">Repeat</label>
                                        <Dropdown
                                          value={repeat}
                                          onChange={e => setRepeat(e.value)}
                                          options={repeatOptions}
                                          optionLabel="name"
                                          placeholder="Select a Repeat Option"
                                          className="w-full search-option"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="Rusername">
                                          Reminder
                                        </label>
                                        <Dropdown
                                          value={reminder}
                                          onChange={e => setReminder(e.value)}
                                          options={reminderOptions}
                                          optionLabel="name"
                                          placeholder="Select a Reminder"
                                          className="w-full search-option"
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col> */}
                              </Row>
                              <Row className="mb-2">
                                <Col lg={6}>
                                  <Row>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label For="Priority" className=" block">
                                          Priority
                                        </label>
                                        <Dropdown
                                          value={priority}
                                          onChange={e => setPriority(e.value)}
                                          options={typeInterview}
                                          optionLabel="name"
                                          placeholder="Priority"
                                          className="w-full search-option"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <Row className="mt-2">
                                        <Col xl={6}>
                                          <div className="d-flex align-items-center mt-4">
                                            <Checkbox
                                              inputId="checkbox"
                                              checked={popchecked}
                                              onChange={handlePopupCheckbox}
                                            />
                                            <label
                                              htmlFor="username"
                                              className="ms-1 mt-2"
                                            >
                                              Completed
                                            </label>
                                          </div>
                                        </Col>
                                        {/* <Col xl={6}>
                                        <div className="d-flex align-items-center mt-4">
                                          <Checkbox
                                            inputId="checkbox"
                                            checked={popchecked2}
                                            onChange={handlePopupCheckbox2}
                                          />
                                          <label
                                            htmlFor="username"
                                            className="ms-1 mt-2"
                                          >
                                            Private
                                          </label>
                                        </div>
                                      </Col> */}
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                            <Row className="">
                              <Col xl={12}>
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-primary waves-light btn btn-primary me-2 btn-main"
                                    onClick={handleSave}
                                  >
                                    <i className="pi pi-save me-1"></i>
                                    Save
                                  </button>
                                  <button
                                    color="primary"
                                    className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                                  >
                                    <i className="pi pi-times me-1"></i>
                                    Cancel
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </p>
                        </Dialog>
                        <Dialog
                          header={`APPOINTMENT${selectedEvent?.created_by_name
                            ? " - " + selectedEvent.created_by_name
                            : ""
                            }`}
                          visible={interviewpop1}
                          className="interview-popup"
                          style={{ width: "50vw" }}
                          onHide={() => SetInterviewpop1(false)}
                        >
                          <p className="bg-form">
                            <div className="mb-4">
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="interview">Type</label>
                                    <InputText
                                      id="interview"
                                      value={interview}
                                      placeholder="Interview"
                                      disabled
                                    />
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="subtype" className="block">
                                      Sub-Type
                                    </label>
                                    <InputText
                                      id="subtype"
                                      value={subtype || ""}
                                      placeholder="Subtype"
                                      disabled
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6}>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field flex-auto">
                                        <label
                                          htmlFor="startdate"
                                          className="block"
                                        >
                                          Start date
                                        </label>
                                        <Calendar
                                          value={startdate}
                                          showIcon
                                          disabled
                                          dateFormat="yy-mm-dd"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex-auto">
                                        <label
                                          htmlFor="starttime"
                                          className="block"
                                        >
                                          Time
                                        </label>
                                        <Calendar
                                          value={starttime}
                                          showIcon
                                          timeOnly
                                          disabled
                                          icon={() => (
                                            <i className="pi pi-clock" />
                                          )}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xl={6}>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="flex-auto">
                                        <label
                                          htmlFor="enddate"
                                          className="block"
                                        >
                                          End date
                                        </label>
                                        <Calendar
                                          value={enddate}
                                          showIcon
                                          disabled
                                          dateFormat="yy-mm-dd"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="flex-auto">
                                        <label
                                          htmlFor="endtime"
                                          className="block"
                                        >
                                          Time
                                        </label>
                                        <Calendar
                                          value={endtime}
                                          showIcon
                                          timeOnly
                                          disabled
                                          icon={() => (
                                            <i className="pi pi-clock" />
                                          )}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                            <div className="mb-4">
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="field">
                                    <label htmlFor="job" className="block mb-0">
                                      Job
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="job"
                                        value={selectedJobTitles}
                                        placeholder="Enter Job"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        disabled
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="field">
                                    <label
                                      htmlFor="contact"
                                      className="block mb-0"
                                    >
                                      Contact
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="contact"
                                        value={selectedContactNames}
                                        placeholder="Enter Contact"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        disabled
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="field">
                                    <label
                                      htmlFor="candidate"
                                      className="block mb-0"
                                    >
                                      Candidate
                                    </label>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <InputText
                                        id="candidate"
                                        value={selectedCandidateNames}
                                        placeholder="Enter Candidate"
                                        className="w-full"
                                        style={{ paddingRight: "2rem" }}
                                        disabled
                                      />
                                      <i
                                        className="pi pi-chevron-down"
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="subject">Subject</label>
                                    <InputText
                                      id="subject"
                                      value={subject}
                                      placeholder="Subject"
                                      disabled
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2 mt-3">
                                <Col xl={12}>
                                  <div className="p-field flex flex-column">
                                    <label htmlFor="description">
                                      Description
                                    </label>
                                    <InputTextarea
                                      id="description"
                                      className="w-full"
                                      value={popTextares}
                                      placeholder="Interview Test"
                                      rows={3}
                                      cols={20}
                                      disabled
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div>
                              <Row className="mb-2">
                                <Col xl={6}>
                                  <div className="p-field">
                                    <label htmlFor="followup">
                                      Auto Followup
                                    </label>
                                    <Dropdown
                                      value={followup}
                                      options={followupOptions}
                                      optionLabel="name"
                                      placeholder="Select a Followup Interval"
                                      className="w-full search-option"
                                      disabled
                                    />
                                  </div>
                                </Col>
                                <Col xl={6}>
                                  <Row>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="repeat">Repeat</label>
                                        <Dropdown
                                          value={repeat}
                                          options={repeatOptions}
                                          optionLabel="name"
                                          placeholder="Select a Repeat Option"
                                          className="w-full search-option"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="reminder">Reminder</label>
                                        <Dropdown
                                          value={reminder}
                                          options={reminderOptions}
                                          optionLabel="name"
                                          placeholder="Select a Reminder"
                                          className="w-full search-option"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="mb-2">
                                <Col lg={6}>
                                  <Row>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label
                                          htmlFor="priority"
                                          className="block"
                                        >
                                          Priority
                                        </label>
                                        <Dropdown
                                          value={priority}
                                          options={typeInterview}
                                          optionLabel="name"
                                          placeholder="Priority"
                                          className="w-full search-option"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <Row className="mt-2">
                                        <Col xl={6}>
                                          <div className="d-flex align-items-center mt-4">
                                            <Checkbox
                                              inputId="checkbox"
                                              checked={popchecked}
                                              disabled
                                            />
                                            <label
                                              htmlFor="checkbox"
                                              className="ms-1 mt-2"
                                            >
                                              Completed
                                            </label>
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="d-flex align-items-center mt-4">
                                            <Checkbox
                                              inputId="checkbox2"
                                              checked={popchecked2}
                                              disabled
                                            />
                                            <label
                                              htmlFor="checkbox2"
                                              className="ms-1 mt-2"
                                            >
                                              Private
                                            </label>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xl={6}>
                                  <label htmlFor="userid">User Id's</label>
                                  <Chips
                                    value={uniqueId}
                                    itemTemplate={customChip}
                                    className="w-full"
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </div>
                            <Row className="">
                              <Col xl={12}>
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                                    onClick={() => SetInterviewpop1(false)}
                                  >
                                    <i className="pi pi-times me-1"></i>
                                    Close
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </p>
                        </Dialog>
                      </div>
                    </div>
                  </section>
                </Col>
              </Row>)}
          </div>
        </Container>
      </div>
      <Dialog
        header="Schedule Interview"
        visible={scheduleCommonPopup}
        className="interview-popup"
        style={{ width: "50vw" }}
        onHide={closeSchedulePopup}
      >
        <form>
          <p className="bg-form calendar-schedule-readonly-form">
            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="interview">
                      Type <span className="text-danger">*</span>
                    </label>
                    <InputText disabled value={"Interview"} />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="integer" className="block">
                      Sub-Type <span className="text-danger">*</span>
                    </label>
                    <Dropdown
                      value={scheduleSubtype}
                      // onChange={(e) => setScheduleSubtype(e.value)}
                      onChange={(e) => {
                        setScheduleSubtype(e.value);
                        setScheduleFormErrors(prev => ({ ...prev, event_sub_type: "" })); // Clear error on change
                      }}
                      options={subtypeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    />
                    {scheduleFormErrors.event_sub_type && (
                      <small className="p-error">{scheduleFormErrors.event_sub_type}</small>
                    )}
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xl={5}>
                  <div className="p-field flex-auto">
                    <label htmlFor="startDate" className="block">
                      Start Date <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="startDate"
                      className="w-100"
                      value={scheduleStartDate}
                      onChange={(e) => setScheduleStartdate(e.value)}
                      showIcon
                      minDate={new Date()}
                      dateFormat="yy-mm-dd"
                      icon={() => <i className="pi pi-calendar" />}
                    />
                    {scheduleFormErrors.start_date && (
                      <small className="p-error">{scheduleFormErrors.start_date}</small>
                    )}
                  </div>
                </Col>
                <Col xl={4}>
                  <div className="p-field flex-auto">
                    <label htmlFor="startTime" className="block">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="startTime"
                      className="w-100"
                      value={scheduleStartTime}
                      onChange={(e) => setScheduleStarttime(e.value)}
                      showIcon
                      timeOnly
                      icon={() => <i className="pi pi-clock" />}
                    />
                    {scheduleFormErrors.start_time && (
                      <small className="p-error">{scheduleFormErrors.start_time}</small>
                    )}
                  </div>
                </Col>
                <Col xl={3}>
                  <div className="flex-auto">
                    <label htmlFor="endTime" className="block">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="endTime"
                      value={scheduleEndTime}
                      onChange={(e) => setScheduleEndTime(e.value)}
                      showIcon
                      timeOnly
                      icon={() => <i className="pi pi-clock" />}
                    />
                    {scheduleFormErrors.end_time && (
                      <small className="p-error">{scheduleFormErrors.end_time}</small>
                    )}
                  </div>
                </Col>
              </Row>
              {/* <Row>
                <Row>
                  <Col xl={12}>                   
                  </Col>
                  <Col xl={6} className="d-none">
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="endDate" className="block">
                            End date <span className="text-danger">*</span>
                          </label>
                          <Calendar
                            id="endDate"
                            value={scheduleEndDate}
                            onChange={(e) => setScheduleEndDate(e.value)}
                            showIcon
                            minDate={scheduleStartDate || new Date()}
                            dateFormat="yy-mm-dd"
                            icon={() => <i className="pi pi-calendar" />}
                          />
                          {scheduleFormErrors.end_date && (
                            <small className="p-error">{scheduleFormErrors.end_date}</small>
                          )}
                        </div>
                      </Col>
                      
                    </Row>
                  </Col>
                </Row>
              </Row> */}
            </div>
            <div className="mb-4">
              <Row className="mb-2">
                <InlineLinkContacts
                  onSelectedJobsChange={(jobs) => {
                    setSelectedScheduleJobs(jobs);
                    setSelectedScheduleCandidates([]);
                    setScheduleFormErrors((prev) => ({ ...prev, job_id: "" }));
                  }}
                  errorJob={scheduleFormErrors.job_id}
                  setSelectedScheduleContacts={(contacts) => {
                    setSelectedScheduleContacts(contacts);
                    setScheduleFormErrors((prev) => ({ ...prev, contacts: "" }));
                  }}
                  errorContact={scheduleFormErrors.contacts}
                  jobLabel={<span>Jobs</span>}
                  selectedJobs={selectedScheduleJobs}
                />
              </Row>

              <Row className="mb-2">
                <InlineLinkCandidate
                  onSelectedCandidatesChange={(candidates) => {
                    setSelectedScheduleCandidates(candidates);
                    setScheduleFormErrors((prev) => ({ ...prev, event_sub_type: "" }));
                  }}
                  error={scheduleFormErrors.candidates}
                  jobId={selectedScheduleJobs?.[0]?.id}
                  label={<span>Candidate</span>}
                  selectedCandidates={selectedScheduleCandidates}
                />
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="username">Subject</label>
                    <InputText
                      placeholder="Subject"
                      value={scheduleSubject}
                      onChange={(e) => setScheduleSubject(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              {/* Note field removed: not used in schedule interview flow.
              <Row className="mb-2 mt-2">
                <Col xl={12}>
                  <div className="">
                    <label htmlFor="username">Note :</label>
                    <InputTextarea
                      className="w-full"
                      value={popTextares}
                      onChange={(e) => setPopTextares(e.target.value)}
                      placeholder="Interview Test"
                      rows={3}
                      cols={20}
                    />
                  </div>
                </Col>
              </Row>
              */}
            </div>
            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="Priority" className="block">
                          Priority
                        </label>
                        <Dropdown
                          value={schedulePriority}
                          onChange={(e) => setSchedulePriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="Priority"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <div className="p-field flex flex-column d-none">
                        <label htmlFor="Duration" className="block">
                          Duration <span className="text-danger">*</span>
                        </label>
                        <Dropdown
                          value={scheduleDuration}
                          onChange={(e) => setScheduleDuration(e.value)}
                          options={[
                            { duration: "15 mins", value: 15 },
                            { duration: "30 mins", value: 30 },
                            { duration: "45 mins", value: 45 },
                            { duration: "60 mins", value: 60 }
                          ]}
                          optionLabel="duration"
                          placeholder="Duration"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4 d-none">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked1}
                              onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>
                        <Col xl={6} className="d-none">
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={schedulepopchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className="d-none">
                  <label htmlFor="username">User Id's</label>
                  <Chips
                    value={userid2}
                    onChange={(e) => setUserid2(e.value)}
                    readOnly
                    className="w-full"
                  />
                </Col>
                <Col xl={6} className="d-none">
                  <div className="p-field flex flex-column">
                    <label htmlFor="reminder">Reminders</label>
                    <Dropdown
                      id="reminder"
                      value={scheduleReminder}
                      onChange={(e) => setScheduleReminder(e.value)}
                      options={reminderOptions}
                      optionLabel="label"
                      placeholder="Reminder"
                      className="w-full search-option"
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mb-2">
              {(selectedSchedule?.name?.toLowerCase() === "meeting" ||
                selectedSchedule?.name?.toLowerCase() === "call") && (
                  <>
                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="repeat">Repeat</label>
                        <Dropdown
                          id="repeat"
                          value={scheduleRepeat}
                          onChange={(e) => {
                            setScheduleRepeat(e.value);
                            setScheduleFormErrors(prev => ({ ...prev, repeat: "" }));
                          }}
                          options={repeatOptions}
                          optionLabel="label"
                          placeholder="Repeat"
                          className="w-full search-option"
                        />
                        {scheduleFormErrors.repeat && (
                          <small className="p-error">{scheduleFormErrors.repeat}</small>
                        )}
                      </div>
                    </Col>
                    {/* <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="autofollowup">Auto Followup</label>
                        <Dropdown
                          id="autofollowup"
                          value={scheduleAutoFollowup}
                          onChange={(e) => {
                            setScheduleAutoFollowup(e.value);
                            setScheduleFormErrors(prev => ({ ...prev, auto_followup: "" }));
                          }}
                          options={autoFollowupOptions}
                          optionLabel="label"
                          placeholder="Auto Followup"
                          className="w-full search-option"
                        />
                        {scheduleFormErrors.auto_followup && (
                          <small className="p-error">{scheduleFormErrors.auto_followup}</small>
                        )}
                      </div>
                    </Col> */}
                    {/* <Col xl={4}>
                                <div className="p-field flex flex-column">
                                  <label htmlFor="reminder">Reminder</label>
                                  <Dropdown
                                    id="reminder"
                                    value={scheduleReminder}
                                    onChange={(e) => setScheduleReminder(e.value)}
                                    options={reminderOptions}
                                    optionLabel="label"
                                    placeholder="Reminder"
                                    className="w-full search-option"
                                  />
                                </div>
                              </Col> */}
                  </>
                )}
              {selectedSchedule?.name?.toLowerCase() !== "meeting" &&
                selectedSchedule?.name?.toLowerCase() !== "call" && (
                  <Col xl={4} className="d-none">
                    <div className="p-field flex flex-column">
                      <label htmlFor="reminder">Reminder</label>
                      <Dropdown
                        id="reminder"
                        value={scheduleReminder}
                        onChange={(e) => setScheduleReminder(e.value)}
                        options={reminderOptions2}
                        optionLabel="label"
                        placeholder="Reminder"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                )}
            </Row>
            <Row className="">
              <Col xl={12}>
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    onClick={handleSaveSchedule}
                    disabled
                  >
                    <i className="pi pi-save me-1"></i>
                    {loadingSave ? (
                      <span className="pi pi-spinner pi-spin" style={{ marginRight: '8px' }}></span>
                    ) : null}
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light me-2"
                    onClick={closeSchedulePopup}
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>
        </form>
      </Dialog>

      <Modal
        isOpen={showReasonForArchive}
        toggle={() => setShowReasonForArchive(false)}
        centered
      >
        <ModalHeader 
          toggle={() => { setShowReasonForArchive(false); setArchiveReason(""); setArchivesaving(false); setArchiveReasonErr(""); }}
          className="modal-header_box blueBtn p-3 d-flex justify-content-between align-items-center m-0"
        >
          <h6 className="m-0 text-white fw-semibold">Reason for Archive</h6>
        </ModalHeader>

        <ModalBody className="p-4">
          <div
            className="border rounded-3 p-3 shadow-sm"
            style={{ background: "#f8f9fa" }}
          >
            <Label className="fw-semibold mb-2">Reason for Archive <span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              rows={1}
              placeholder="Enter the reason..."
              value={archiveReason}
              onChange={(e) => setArchiveReason(e.target.value)}
            />
            <small className="text-danger">{ArchiveReasonErr}</small>
            <div className="d-flex justify-content-center mt-2 gap-1">
              <button className="btn blueBtn"
                onClick={() => { setShowReasonForArchive(false); setArchiveReason(""); setArchivesaving(false); setArchiveReasonErr(""); }}
                disabled={Archivesaving}
              >
                Cancel
              </button>
              <button
                className="btn addBtn mt-2" style={{ height: "40px" }}
                onClick={handleSaveArchive}
                disabled={Archivesaving}
              >
                {Archivesaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    <Modal
      isOpen={showShareModal}
      toggle={() => setShowShareModal(false)}
      centered
    >
      <ModalHeader toggle={() => setShowShareModal(false)}>
        Share Event Details
      </ModalHeader>
      <ModalBody>
            {loading1 ? (
              <div className="text-center py-4">
                <CustomLoader/>
              </div>
            ) : (
              <div>
                <div className="inline-block">
                    <label className="mt-2 me-2">Select Company</label>
                    <div style={{ display: "inline-block", width: "170px",}} className="me-1">
                      <Input
                           className="mb-3"
                           type="select"
                           value={modalCompanyId  || ""}
                           onChange={handleCompanyChange1}
                         >
                           {companies.map(company => (
                             <option key={company.company_id} value={company.company_id}>
                               {company.company_domain}
                             </option>
                           ))}
                         </Input>
                  </div>
                  </div>
                <h6>Select Employee/Recruiter</h6>
               <MultiSelect
                value={selectedRecruiters}
                options={filteredRecruiters}
                onChange={handleRecruiterChange}
                placeholder="Select Employee/Recruiter"
                display="chip"
                showSelectAll
                filter
                className="w-100"
                appendTo={document.body}
                scrollHeight="200px"
                tooltip={recruiterTooltip}
                tooltipOptions={{ position: "top" }}
                filterTemplate={() => (
                    <input
                      type="text"
                      className="p-inputtext p-component w-100"
                      placeholder="Search..."
                      value={recruiterFilter}
                      onChange={(e) => setRecruiterFilter(e.target.value)}
                    />
                  )}
              />
                  {typeInterviewcontact.length === 0 && (
                    <div className="text-muted mt-2">No recruiters found</div>
                  )}
              </div>
            )}
        <div className="mt-3">
        <h6>Candidate Names:</h6>
        {selectedEventForShare?.candidate_ids?.map((candidate, index) => (
          <div key={index} className="d-flex align-items-center mb-2">
            <Checkbox
              checked={selectedCandidates.includes(candidate.id)}
              onChange={(e) => {
                if (e.checked) {
                  setSelectedCandidates([...selectedCandidates, candidate.id]);
                } else {
                  setSelectedCandidates(selectedCandidates.filter(id => id !== candidate.id));
                }
              }}
              className="me-2"
            />
            <span>{candidate.name}</span>
          </div>
        ))}
      </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button color="secondary" onClick={() => setShowShareModal(false)}>
          Cancel
        </Button>
      <Button
          color="primary"
          disabled={isSharing}
          onClick={async () => {
            const recruiterContacts = typeInterviewcontact || [];
            const candidateList = selectedEventForShare?.candidate_ids || [];
            const selectedRecruiterNames = recruiterContacts
              .filter(contact => selectedRecruiters.includes(contact.id))
              .map(contact => contact.name)
              .join(", ");
            const selectedCandidateNames = candidateList
              .filter(candidate => selectedCandidates.includes(candidate.id))
              .map(candidate => candidate.name)
              .join(", ");

            if (selectedRecruiters.length === 0 && selectedCandidates.length === 0) {
              Swal.fire({
                icon: "warning",
                title: "Selection Required",
                text: "Please select at least one recruiter or candidate to share with.",
              });
              return;
            }

            try {
              setIsSharing(true);
              // Call the API
              const response = await axios.post(
                "/api/v1/meeting-invite/",
                {
                  candidate_ids: selectedCandidates,
                  employee_ids: selectedRecruiters,
                  calendar_id: selectedEventForShare.calendar_id,
                },
              );

              if (response.status === 200 || response.status === 201) {
                Swal.fire({
                  icon: "success",
                  title: "Meeting Link Shared Successfully!",
                  html: `
                    <p><strong>Employees:</strong> ${selectedRecruiterNames || "None"}</p>
                    <p><strong>Candidates:</strong> ${selectedCandidateNames || "None"}</p>
                  `,
                  confirmButtonText: "OK",
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Failed to Share Meeting Link",
                  text: "Please try again later.",
                });
              }
            } catch (error) {
              console.error("Error sharing meeting link:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to share meeting link. Please try again.",
              });
            } finally {
              setIsSharing(false);
              setShowShareModal(false);
            }
          }}
        >
          {isSharing ? "Sharing..." : "Share"}
        </Button>
      </ModalFooter>
    </Modal>
      <SuccessErrorPopup
        show={errorAlert}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
        isSuccess={isSuccess}
      />
    </React.Fragment>
  )
}

export default CalenderAll
